import style from './newrodin.module.css'
import '../../index.css'
import React, { useCallback, useContext, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from 'react'

//hooks api
import { useTips } from '../../common/GlobalTips'
import {
    cardsAtom,
    cardsTypeAtom,
    logInfoAtom,
    modalObjAtom,
    processedPrompt,
    rodinGenPipeline,
    rodinInitWeightAtom,
    rodinUploadedImages,
    showLoginAtom,
    showSubscribeAtom,
    isRodinGeneratingAtom,
    userPermissionAtom,
    taskDetailAtom,
    haveSearchTabAtom,
    isFeedbackModalOpenAtom,
    showReferralAtom,
    showApiDashboardAtom,
    defaultFaceEnhanceAtom,
    allowFaceEnhanceAtom,
    isAnnotatorOpenAtom,
    isFirstScreenShowAtom,
    storyListAtom,
    storyListVisibleAtom,
    storyHomePageJumpAtom,
    promotionsAtom,
} from '../../store'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { RODINWEIGHTS } from '../../utils/map'
import { trackEvent } from '../../utils/trackEvent'
import { cancelRequest, getCards, getTaskDetail, prompt2Img, rodinMesh, rodinPreprocessImage } from "../../utils/net";
import { checkMobile, getImageDimensions, isHasAlpha, isHasAlpha2, pos2Base64, rodinUploadCompressImg } from '../../utils/format'
import { useTranslation } from "react-i18next";
import { CardClickContext, CardDataContext, PermissionContext } from '../../utils/context'
import { useParams } from 'react-router-dom';
import { LuPencilLine } from "react-icons/lu";
import { BsCheckLg } from "react-icons/bs";
import { resetGenPipeline } from "../../utils/format";
import * as Sentry from "@sentry/react";
import { useWebSocket, useThrottle, isPrerenderUserAgent, useDebounceEffect, useNewUserPromotionCountdown } from '../../utils/hooks'
import ModelSearchBox from './components/Search'
import Ominicraft from './components/Ominicraft'

//component
import HeaderMobile from '../../mobilecomponents/header'
import Header from '../Header'
import Footer from '../Footer'
import { Menu } from '../widgets/Menu'
import { HomePagePrivate } from './components/Private'
import Prerender from './components/Prerender'
import ScrollLoader from '../../common/ScrollLoader'
import { RodinWallet } from './components/Wallet'
import { Onboard } from "./components/Onboard";
import { EmptyComponent, LoadingSkeleton, RodinCard } from './components/Card'
const ModelPresets = React.lazy(() => import('./components/ModelPresets'));

//Assets
import Incorrect from './assets/Incorrect.png'
import refresh from './assets/refresh.png'
import correct from './assets/correct.png'
import deletePng from './assets/delete.png'
import DOWN from './assets/down.png'
import transparentBg from './assets/uploadBg.png'
import smallBox from './components/ModelPresets/assets/small_box.png'
import bigBox from './components/ModelPresets/assets/big_box.png'
import pointcloud from './components/ModelPresets/assets/pointcloud-home.png'
import voxel from './components/ModelPresets/assets/voxel-home.png'
import bbox from './components/ModelPresets/assets/bbox-home.png'
import voxelCover from './components/ModelPresets/assets/voxelCover.png'
import pointcloudCover from './components/ModelPresets/assets/pointcloudCover.png'
import Restricted from "../../utils/restricted";
import { controllerInfoAtom } from '../../store/rodin'
import { openDB } from 'idb'
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import { RodinDriverAnimation, RodinTextDriverAnimation } from './components/RodinDriverAnimation'
// import Particles from "react-tsparticles";
// import { loadFull } from 'tsparticles';

import defaultIcon from './components/ModelPresets/assets/defaultIcon.png'
import StoryComponent from './components/Story'
import CashBack from './components/CashBack'
import { StorySharingBonus } from './components/StoryPost'
import ImageAnnotator from './components/ImageRecognition/ImageAnnotator.planb'
import cropIcon from './assets/crop.png'
import NewUserPromotion from '../Promotional/NewUserPromotion'
import ReactGA from "react-ga4";

let imgNameArr = []
const isMobile = checkMobile()
const defaultMeshParameters = {
    'default': {
        entryname: 'defaultIcon',
        name: 'defaultIcon',
        img: defaultIcon,
        confirmed: true,
    },
    'bbox': {
        entryname: 'Bounding Box',
        img: bbox,
        cover_small: smallBox,
        cover_big: bigBox,
        default_cover: smallBox,
        originFile: null,
        confirmed: false,
        params: [100, 100, 100, 1],
        pos: { x: 100, y: 100, z: 100 },
        rotation: [0, 0, 0]
    },
    'voxel': {
        entryname: 'Voxel',
        img: voxel,
        default_cover: voxelCover,
        cover_small: null,
        cover_big: null,
        confirmed: false,
        originFile: null,
        params: [],
        pos: [],
        voxel_condition_cfg: true,
        voxel_condition_weight: 1.00,
        wlhparams: { x: 1, y: 1, z: 1 },
        rotation: [0, 0, 0]
    },
    'pointCloud': {
        entryname: 'Point Cloud',
        img: pointcloud,
        default_cover: pointcloudCover,
        cover_small: null,
        cover_big: null,
        originFile: null,
        confirmed: false,
        params: [],
        pos: [],
        wlhparams: { x: 1, y: 1, z: 1 },
        pcd_condition_uncertainty: 0.010,
        rotation: [0, 0, 0]
    }
}
function NewRodin() {
    const PageOneRef = useRef(null)
    const pageTwoRef = useRef(null)
    const rodinPageRef = useRef(null)
    const [togglePage,] = useState(false)
    const params = useParams();
    const [scrollLength, setScrollLength] = useState(0)
    const handleCardClick = useContext(CardClickContext);
    const { isAllowedTo } = useContext(PermissionContext);
    const [, setShowSubscribe] = useRecoilState(showSubscribeAtom);
    const [, setShowReferral] = useRecoilState(showReferralAtom);
    const [, setShowApiDashboard] = useRecoilState(showApiDashboardAtom);
    const pathToShowStateMap = React.useMemo(() => ({
        '/subscribe': setShowSubscribe,
        '/referral': setShowReferral,
        '/api-dashboard': setShowApiDashboard,
    }), []);


    useEffect(() => {
        const path = location.pathname;
        Object.entries(pathToShowStateMap).forEach(([pathName, setFunc]) => {
            if (path === pathName) {
                setFunc(true);
            } else {
                setFunc(false);
            }
        });
    }, [location, pathToShowStateMap]);

    useEffect(() => {
        if (params.taskUUid) {
            handleCardClick(params.taskUUid);
        }
    }, [])


    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            setScrollLength(scrollTop);
        };
        if (PageOneRef?.current?.pageoneContainer) {
            window.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (PageOneRef?.current?.pageoneContainer) {
                window.removeEventListener('scroll', handleScroll);
            }
        }
    }, [PageOneRef.current])

    const isMobile = checkMobile()

    // for SEO canonical purpose
    const showGalleryCondition = !params.taskUUid || !isPrerenderUserAgent()

    return (
        <div
            ref={rodinPageRef}
            className='flex relative flex-col items-center transition-300-ease-in-out min-h-[100vh] overflow-x-hidden overflow-y-scroll [-webkit-overflow-scrolling:auto]'>
            <div className='fixed z-[-1] left-[10vw] top-[-10%] w-[50vw] h-[50vw] rounded-full 
                        bg-[radial-gradient(circle,#C111FF4D,transparent,#121317)]
                        bg-no-repeat  
                        blur-[100px]
                        '/>
            <div className='fixed z-[-1] left-[-10%] top-[10%] w-[30vw] h-[30vw] rounded-full 
              bg-[radial-gradient(circle,#11F1FF80,transparent,#121317)]
              bg-no-repeat  
              blur-[100px]
              '/>
            <div className='fixed z-[-10] right-[-10%] top-[20%] w-[50vw] h-[50vw] rounded-full 

              bg-[radial-gradient(circle,#11F1FF80,transparent,#121317)]
              bg-no-repeat  
              blur-[100px]
              ' />

            <div className='fixed z-[-10] right-0 bottom-[-10vw] w-[100vw] h-[100vw] rounded-full 
              bg-[radial-gradient(circle,#11F1FF80,transparent,#121317)]
              bg-no-repeat  
              blur-[100px]
              ' />
            <PageOne togglePage={togglePage} scrollLength={scrollLength} ref={PageOneRef} />

            {showGalleryCondition && (
                <PageTwo togglePage={togglePage} scrollLength={scrollLength} ref={pageTwoRef} />
            )}
            {!isMobile && isAllowedTo('footer.rodin.view') && <Footer />}

        </div>
    )
}

const PageOne = React.forwardRef(({ scrollLength }, ref) => {
    const isMobile = checkMobile()
    const boundingBoxRef = useRef(null);
    const pageoneContainer = useRef(null);
    const [isFeedbackModalOpen,] = useRecoilState(isFeedbackModalOpenAtom);
    const { resetCountdown } = useNewUserPromotionCountdown();
    const setPromotions = useSetRecoilState(promotionsAtom);


    useImperativeHandle(ref, () => ({
        boundingBoxRef: boundingBoxRef.current,
        pageoneContainer: pageoneContainer.current
    }));

    const handlePageOneClick = (e) => {
        !isFeedbackModalOpen && e.stopPropagation()
        if (boundingBoxRef.current && !boundingBoxRef.current.threeWrapper.current.contains(e.target)) {
            boundingBoxRef.current.exitUploadStatus()
            const generateBtn = document.querySelector('#rodinGenerateBtn')
            if (generateBtn && generateBtn.contains(e.target)) return
            boundingBoxRef.current.handleCloseBoundingBox(e)
        }
    }

    const [showPromotion, setShowPromotion] = useState(false);

    // Trigger animation
    const handleShowPromotion = () => {
        setShowPromotion(true);
    };

    const handleClearPromotion = () => {

        resetCountdown()
        setPromotions(prev => ({ ...prev, newUser: { ...prev.newUser, show: false } }));
        // Use setTimeout to ensure the state update is complete before refreshing the page
        setTimeout(() => {
            // window.location.reload();
        }, 0);
    }


    return (
        <div onClick={handlePageOneClick} ref={pageoneContainer} className={`w-[100vw] mt-[70px] flex-center relative transition-300-ease pt-[90px] sm:pt-[140px] lg:pt-[176px] xl:pt-[160px]`}>
            <div>
                <Restricted to='featured.new_user_promotion'>
                    <NewUserPromotion
                        isOpen={showPromotion}
                        onClose={() => setShowPromotion(false)}
                    />
                </Restricted>
                {/* <button className='fixed top-1/2 left-0 border border-red-500 rounded-md p-2' onClick={handleClearPromotion}>清除促销缓存并刷新</button> */}
            </div>
            <div className='size-full flex-center'>

                <div className='flex items-center max-w-[calc(1600px+9rem)] w-full h-full px-[100px] md:px-[160px]'>

                    <div className={`flex items-center justify-center w-full h-auto ${!isMobile && 'min-w-[747px]'} max-w-[1757px] max-h-[816px]`}>
                        <UploadArea boundingBoxRef={boundingBoxRef} scrollLength={scrollLength} handleShowPromotion={handleShowPromotion} />
                    </div>
                </div>
            </div>
        </div>
    )
})

const PageTwo = React.forwardRef((props, ref) => {
    const [cardsType, setCardsType] = useRecoilState(cardsTypeAtom);
    const [cards, setCards] = useRecoilState(cardsAtom);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [galleryStatus, setGalleryStatus] = useState('DEFAULT')
    const [showStorySidebar, setShowStorySidebar] = useState(false)
    const pageRef = useRef(0);
    const galleryRef = useRef(null);
    const ScrollLoaderRef = useRef(null);
    const [cacheCardList, setCacheCardList] = useState([]);
    const [allLoaded, setAllLoaded] = useState(false)
    const [hoverID, setHoverID] = useState(false);
    const params = useParams();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const tip = useTips();
    const [isInitialized, setIsInitialized] = useState(false);

    const [selectedFilter, setSelectedFilter] = useState({
        Preview: {
            tags: ['ModelGenerate'],
            status: true
        },
        Geometry: {
            tags: ['ModelRefine', 'TextureGenerate'],
            status: true
        },
        Material: {
            tags: ['TextureRefine'],
            status: true
        },
        Hide: {
            tags: [],
            status: false
        }
    });
    const selectedTagKeys = useMemo(() =>
        Object.keys(selectedFilter)
            .filter(key => selectedFilter[key].status)
            .map(key => Array.isArray(selectedFilter[key].tags) ? selectedFilter[key].tags : [])
            .flat(Infinity),
        [selectedFilter]
    );

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            setCards([]);
            // setCardsType('Featured')
            setCardsType('Mine')
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useImperativeHandle(ref, () => ({
        scrollTop: galleryRef?.current?.scrollTop,
    }), [ref, galleryRef?.current?.scrollTop]);

    const searchRef = useRef();
    const haveSearchTab = useRecoilValue(haveSearchTabAtom);
    const fetchSearchCard = async () => {
        try {
            const res = await searchRef.current.loadMore(pageRef.current++)
            if (res?.length) {
                setGalleryStatus('DEFAULT')
                setCards(pre => [...pre, ...res])
                setCacheCardList(pre => [
                    ...pre,
                    ...(
                        Array.isArray(res) ?
                            res.map(item => ({
                                task_uuid: item.task_uuid,
                                SDFcached: false
                            })) :
                            []
                    )
                ])
                pageRef.current++
                if (res.length < 24) {
                    throttleFetch()
                }
            } else {
                if (pageRef.current === 0) {
                    setCards([])
                    setCacheCardList([])
                    setAllLoaded(true)
                } else {
                    setAllLoaded(true)
                }
            }
            setIsLoading(false)
        } catch (error) {
            Sentry.captureException(error)
            tip({
                type: 'error',
                content: `Request failed, please try again later.${error}`,
            });
        } finally {
            if (!cancelRequest) {
                setIsLoading(false)
            }
        }
    }
    const logInfo = useRecoilValue(logInfoAtom);


    const fetchCard = async () => {
        try {
            if (cardsType === "Mine" && !logInfo) {
                setShowLogin(true)
                return
            }
            const fetchRes = await getCards({ type: cardsType, page_num: pageRef.current, user_type: 'All', task_type: 'Rodin', needCancel: true, task_step: selectedTagKeys, is_hidden: (cardsType === 'Mine' && selectedFilter.Hide.status) })
            if (fetchRes?.data) {
                if (fetchRes.data.length) {
                    isPrerenderUserAgent() ? setGalleryStatus('PRERENDER') : setGalleryStatus('DEFAULT');
                    setCards(pre => [...pre, ...fetchRes.data])
                    setCacheCardList(pre => [
                        ...pre,
                        ...(
                            Array.isArray(fetchRes.data) ?
                                fetchRes.data.map(item => ({
                                    task_uuid: item.task_uuid,
                                    SDFcached: false
                                })) :
                                []
                        )
                    ])
                    pageRef.current++
                    if (fetchRes.data.length < 24) {
                        throttleFetch()
                    }
                } else {
                    if (pageRef.current === 0) {
                        setCards([])
                        setCacheCardList([])
                        setAllLoaded(true)
                    } else {
                        setAllLoaded(true)
                    }

                }
                setIsLoading(false)
            }
        } catch (error) {
            Sentry.captureException(error)
            tip({
                type: 'error',
                content: `Request failed, please try again later.${error}`,
            });
        } finally {
            if (!cancelRequest) {
                setIsLoading(false)
            }
        }
    }
    const throttleFetch = useThrottle(fetchCard, 100)
    const throttleFetchSearchCard = useThrottle(fetchSearchCard, 100)

    useDebounceEffect(() => {
        // if (!isInitialized) return;

        if (cancelRequest) {
            cancelRequest.cancel('CardType changed');
        }
        setAllLoaded(false);
        setIsLoading(true);
        pageRef.current = 0;

        // Use setTimeout to ensure state update is complete
        setTimeout(() => {
            if (cardsType === 'Story') {
                setShowStorySidebar(false)
                setGalleryStatus('STORY')
                setIsLoading(true)
                requestAnimationFrame(() => {
                    setCards([])
                })
            } else {
                setCards([]);
                setGalleryStatus('DEFAULT');
                if (haveSearchTab) {
                    fetchSearchCard();
                } else {
                    fetchCard();
                }
                setShowStorySidebar(true);
            }
        }, 0);
    }, [cardsType, selectedTagKeys, haveSearchTab], 100);

    const expandAnimation = {
        initial: {
            opacity: 0,
            transform: "scale(0.2)",
            transformOrigin: "top right"
        },
        animate: {
            opacity: 1,
            transform: "scale(1)",
            transition: {
                type: "tween",
                duration: 0.5,
                ease: "easeOut"
            }
        },
        exit: {
            scale: 0.3,
            opacity: 0,
            transition: {
                duration: 0.2
            }
        }
    }

    // Add animation state control
    const [isAnimating, setIsAnimating] = useState(false);
    const menuRef = useRef(null);
    const setStoryHomePageJump = useSetRecoilState(storyHomePageJumpAtom);

    // Add state control for whether to use Story special animation
    const [useStoryAnimation, setUseStoryAnimation] = useState(false);

    const handleHomePageJump = useCallback((story) => {
        setIsAnimating(true);
        setUseStoryAnimation(true); // Set to use Story animation
        requestAnimationFrame(() => {
            setIsAnimating(false);
            menuRef.current.toggleCardType('Story');
            setGalleryStatus('STORY');
            setStoryHomePageJump(story?.id);
        });
    }, []);

    useEffect(() => {
        if (cardsType !== 'Story') {
            setUseStoryAnimation(false);
        }
    }, [cardsType]);

    // Define animation configurations for all states
    const galleryAnimations = {
        initial: {
            opacity: 0,
            scale: 0.95
        },
        animate: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.3,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            scale: 0.95,
            transition: {
                duration: 0.2
            }
        }
    }

    const loadMore = () => {
        if (cardsType === 'Story') {
            return
        }
        if (haveSearchTab) {
            throttleFetchSearchCard()
        } else {
            throttleFetch()
        }
    }

    const GalleryComponent = {
        'DEFAULT': (
            <ScrollLoader ref={ScrollLoaderRef} width='100%' loadMore={loadMore} allLoaded={allLoaded}>
                {isLoading ? (
                    <LoadingSkeleton windowWidth={windowWidth} />
                ) : cards.length === 0 ? (
                    <EmptyComponent />
                ) : (
                    cards.map((card, index) => (
                        <CardDataContext.Provider key={index} value={card}>
                            <RodinCard
                                keyIndex={index}
                                card={card}
                                isMine={cardsType === 'Mine'}
                                selectedFilter={selectedFilter}
                                hoverID={hoverID}
                                setHoverID={setHoverID}
                                cacheCardList={cacheCardList}
                                setCacheCardList={setCacheCardList} />
                        </CardDataContext.Provider>
                    ))
                )}
            </ScrollLoader>
        ),
        'PRERENDER': <Prerender />,
        'STORY': (
            <motion.div
                className='flex w-full justify-center gap-[16px]'
                // 根据useStoryAnimation决定是否使用特殊动画
                {...(useStoryAnimation ? {
                    initial: expandAnimation.initial,
                    animate: expandAnimation.animate,
                    exit: expandAnimation.exit
                } : {
                    initial: galleryAnimations.initial,
                    animate: galleryAnimations.animate,
                    exit: galleryAnimations.exit
                })}
            >
                <StoryComponent />
                <div className='flex flex-col gap-[16px]'>
                    <StorySharingBonus />
                    {/* <CashBack /> */}
                </div>
            </motion.div>
        )
    }
    const isMobile = checkMobile();

    return (
        <div className={`w-full transition-all duration-100 flex justify-between items-start relative mb-[auto] px-[60px] max-w-[none] lg:max-w-[1500px] xl:max-w-[1800px] 2xl:max-w-[2500px]`}>
            <div ref={ref} className={`pt-[40px] w-full h-full flex flex-col items-center transition-300-ease`}>
                <div className={`w-full ${galleryStatus === 'STORY' ? isMobile ? 'px-[20px]' : '' : 'px-[20px]'} flex flex-col items-start max-w-[none] sm:max-w-[1800px] md:max-w-[2000px] transition-300-ease`}>
                    <h2 className='text-white text-3xl font-bold'>{t('RODIN_GALLERY_HEAD_TITLE')}</h2>
                    <div className='w-full flex items-center justify-between'>
                        <Menu ref={menuRef} menuType="newRodin" />

                        <Filter
                            galleryStatus={galleryStatus}
                            setSelectedFilter={setSelectedFilter}
                            disabled={haveSearchTab}
                            selectedFilter={selectedFilter}
                            searchRef={searchRef} />
                    </div >
                </div >
                <AnimatePresence mode="wait">
                    <motion.div
                        key={galleryStatus}
                        ref={galleryRef}
                        className={`w-full pb-[40px] max-w-[none] sm:max-w-[1800px] md:max-w-[2000px] flex flex-wrap gap-4 content-start justify-center h-full
              ${cards.length === 0 ? "overflow-hidden" : "overflow-scroll"}`}
                        {...galleryAnimations}
                    >
                        {GalleryComponent[galleryStatus]}
                    </motion.div>
                </AnimatePresence>
            </div>

            {/* {showStorySidebar && !isMobile ? (
        <div
          className={`hidden xl:block xl:w-[330px] 2xl:w-[350px] flex-shrink-0 items-start pt-[160px] relative [transform-origin:top_right]`}
        >
          <Ominicraft />
          <StoryComponent handleHomePageJump={handleHomePageJump} type="mini" />
        </div>
      ) : null} */}
        </div>

    )
})


const Filter = ({ setSelectedFilter, selectedFilter, searchRef, disabled, galleryStatus }) => {
    const [openMenu, setOpenMenu] = useState(false)
    const [cardsType] = useRecoilValue(cardsTypeAtom);

    const filterListRef = useRef(null)
    const tip = useTips();
    const { t } = useTranslation();

    const handleOpen = () => {
        if (disabled) return
        trackEvent('Rodin - Filter: Open')
        setOpenMenu(pre => !pre)
    }

    useEffect(() => {
        if (openMenu) {
            window.addEventListener('click', handleClickOutside)
        }
        return () => {
            if (!openMenu) {
                window.removeEventListener('click', handleClickOutside)
            }
        }
    }, [openMenu])

    const handleClickOutside = (event) => {
        if (filterListRef.current && !filterListRef.current.contains(event.target)) {
            setOpenMenu(false)
        }
    }

    const toggleStatus = (key) => {
        const activeKeys = Object.keys(selectedFilter).filter(key => selectedFilter[key]?.status);
        if (activeKeys.length === 1 && activeKeys[0] === key) {
            tip({
                type: 'warning',
                content: t('TIP_WRAN_NEWRODIN_FILTER'),
            });
            return
        }
        trackEvent('Rodin - Filter - Menu: Click', { selected: key })
        setSelectedFilter(prevState => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                status: !prevState[key]?.status
            }
        }))
    }

    const LangFilterArr = [
        {
            name: t('RODIN_GALLERY_HEAD_FILTER_TIPS_1'),
            selected: 'Preview',
        },
        {
            name: t('RODIN_GALLERY_HEAD_FILTER_TIPS_2'),
            selected: 'Geometry',
        },
        {
            name: t('RODIN_GALLERY_HEAD_FILTER_TIPS_3'),
            selected: 'Material',
        },
        // {
        //   name: 'Hide',
        //   selected: 'Hide',
        // },
    ].filter(filter => {
        if (cardsType === 'M') {
            return true;
        }
        return filter.selected !== 'Hide';
    })

    return (
        <div ref={filterListRef} className={`flex relative justify-end items-center w-full select-none transition-300-ease ${galleryStatus !== 'STORY' ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`} >
            <Restricted to="search.rodin.view">
                <ModelSearchBox ref={searchRef} />
            </Restricted>
            <div onClick={handleOpen} className={`bg-[rgba(255,255,255,0.1)] relative transition-300-ease text-white px-4 py-2 rounded-xl flex flex-row gap-2 items-center my-4 ${disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-[rgba(255,255,255,0.15)]"}`}>
                {t('RODIN_GALLERY_HEAD_FILTER')}
                <img className={`w-2.5 h-1.5 [transition:all_0.3s_ease] ${openMenu ? '[transform:rotateX(180deg)]' : ''}`} src={DOWN} alt='down' />
            </div>
            <div className={`absolute z-[201] transition-300-ease bg-[rgba(rgba(0,0,0,0.2))] overflow-hidden rounded-xl top-12 flex flex-col justify-start items-start backdrop-blur-xl before:[-webkit-mask-image:linear-gradient(red,red),linear-gradient(red,red)] before:[-webkit-mask-clip:padding-box,content-box] before:absolute before:z-[-10] before:box-border before:content-[""] before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:block before:[border-radius:inherit] before:p-px before:bg-[linear-gradient(136deg,_rgba(255,_255,_255,_0.5)_0%,_rgba(255,_255,_255,_0.18)_49.19%,_rgba(255,_255,_255,_0.5)_100%)] before:bg-clip-padding before:[mask-composite:exclude] ${openMenu ? 'opacity-100 visible' : 'invisible opacity-0'}`}>

                {LangFilterArr.map((item, index) => {
                    return (
                        <div key={index} onClick={toggleStatus.bind(null, item.selected)} className={`group flex transition-300-ease px-4 py-3.5 first:pt-5 last:pb-5 flex-row gap-2.5 flex-1 items-start w-full text-[14px]  cursor-pointer  ${selectedFilter[item.selected]?.status ? 'hover:bg-[rgba(255,_255,_255,0)]' : 'hover:bg-[rgba(255,_255,_255,_0.1)]'}`}>
                            <span className={`flex items-center justify-center h-[0.7rem] w-[0.7rem] [transition:all_0.3s_ease] aspect-square border-[1px] mt-1 border-[rgba(170,170,170,1)] rounded-[1.33px] ${selectedFilter[item.selected]?.status ? 'border-[rgba(255,_255,_255,1)]' : ''}`}>
                                {selectedFilter[item.selected]?.status && <BsCheckLg />}
                            </span>
                            <span className={`font-[Arial] [transition:all_0.3s_ease] text-[16px] font-normal leading-[18.4px] text-[rgba(255,_255,_255,_0.5)] group-hover:text-[rgba(255,_255,_255,_0.8)] ${selectedFilter[item.selected]?.status ? 'text-[rgba(255,_255,_255,1)] group-hover:text-[rgba(255,_255,_255,1)]' : ''}`}>{item.name}</span>
                        </div>)
                })}

            </div>
        </div>

    )
}

const UploadArea = ({ scrollLength, boundingBoxRef, handleShowPromotion }) => {
    const [currentStatus, setCurrentStatus] = useState(false)
    const [uploading, setUploading] = useState([])
    const [uploadImageRaw, setUploadImgRaw] = useState([]);
    const [generateDisabled, setGenerateDisabled] = useState(true);
    const [checkAlpha, setCheckAlpha] = useState(false)
    const [showOnboard, setShowOnboard] = useState(false)
    const logInfo = useRecoilValue(logInfoAtom);
    const { isAllowedTo } = useContext(PermissionContext);
    const [initAlphaInfo, setInitAlphaInfo] = useState({
        initStatus: true,
        allAlpha: true
    });
    const [meshParameters, setMeshParameters] = useState(defaultMeshParameters)
    const [imageRecognitionInfo, setImageRecognitionInfo] = useState([])
    const [isAnnotatorOpen, setIsAnnotatorOpen] = useRecoilState(isAnnotatorOpenAtom);
    const genrateAreaRef = useRef(null)
    const inputAreaRef = useRef(null)

    // Onboard Component
    useEffect(() => {
        if (!localStorage.getItem('doneRodinOnboard') && localStorage.getItem('user_uuid') && !isMobile) {
            setShowOnboard(true)
        }
    }, [logInfo])

    return (
        <div className='flex flex-col items-center h-full justify-between gap-2'>
            {isAnnotatorOpen?.status && (() => {
                let initialData = imageRecognitionInfo.filter((item) => item.name === isAnnotatorOpen?.name)[0]
                if (isAnnotatorOpen?.isCrop) {
                    initialData = isAnnotatorOpen?.data
                }
                return (
                    <ImageAnnotator
                        uploadImageRaw={uploadImageRaw}
                        initialData={initialData}
                        isOpen={isAnnotatorOpen}
                        genrateAreaRef={genrateAreaRef}
                        inputAreaRef={inputAreaRef}
                    />
                )
            })()}
            {showOnboard && isAllowedTo('rodin.onboard.view') && (<Onboard setShowOnboard={setShowOnboard} />)}
            <TitleArea scrollLength={scrollLength} />
            <InputArea
                ref={inputAreaRef}
                boundingBoxRef={boundingBoxRef}
                checkAlpha={checkAlpha}
                scrollLength={scrollLength}
                currentStatus={currentStatus}
                uploadImageRaw={uploadImageRaw}
                initAlphaInfo={initAlphaInfo}
                meshParameters={meshParameters}
                setMeshParameters={setMeshParameters}
                setInitAlphaInfo={setInitAlphaInfo}
                setGenerateDisabled={setGenerateDisabled}
                setCheckAlpha={setCheckAlpha}
                setUploadImgRaw={setUploadImgRaw}
                setUploading={setUploading}
                imageRecognitionInfo={imageRecognitionInfo}
                setImageRecognitionInfo={setImageRecognitionInfo} />
            <GenrateArea
                ref={genrateAreaRef}
                setMeshParameters={setMeshParameters}
                boundingBoxRef={boundingBoxRef}
                scrollLength={scrollLength}
                generateDisabled={generateDisabled}
                uploadImageRaw={uploadImageRaw}
                uploading={uploading}
                currentStatus={currentStatus}
                meshParameters={meshParameters}
                initAlphaInfo={initAlphaInfo}
                checkAlpha={checkAlpha}
                imageRecognitionInfo={imageRecognitionInfo}
                setCheckAlpha={setCheckAlpha}
                setCurrentStatus={setCurrentStatus}
                inputAreaRef={inputAreaRef}
                setImageRecognitionInfo={setImageRecognitionInfo}
                handleShowPromotion={handleShowPromotion}
            />
        </div>
    )
}

const TitleArea = ({ scrollLength }) => {
    const { t } = useTranslation();
    const { scrollY } = useScroll();
    const y = useTransform(scrollY, [0, 300, 700], [0, 0, -400]);
    const [animationPhase, setAnimationPhase] = useState(0);
    const isFirstScreenShow = useRecoilValue(isFirstScreenShowAtom);

    useEffect(() => {
        if (isFirstScreenShow) {
            // 开始划线动画
            setTimeout(() => {
                setAnimationPhase(1);
            }, 1000);

            // 旧文字消失，新文字出现
            setTimeout(() => {
                setAnimationPhase(2);
            }, 2000);
        }
    }, [isFirstScreenShow]);

    return (
        <motion.div
            className='fixed top-[100px]  xl:top-[110px] w-full'
            // top-[30px] sm:top-[50px] lg:top-[76px] xl:top-[100px]
            style={{
                y,
                willChange: 'transform', // FIX:Title intermittent jitter problem
            }}
        >
            <div className='flex flex-col gap-2 md:gap-3 items-center'>
                <div>
                    <svg className='w-[213px] h-[49px] sm:w-[356px] sm:h-[78px] md:w-[391px] md:h-[85px] lg:w-[427px] lg:h-[93px]'
                        viewBox="0 0 356 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className='fill-transparent stroke-white rodin-title-animation'
                            d="M22.1133 48.8711V63.9883H26.4492C29.3398 63.9883 31.3906 64.5547 32.6016 65.6875C33.8516 66.7812 34.4766 68.2266 34.4766 70.0234C34.4766 71.7812 33.8516 73.2266 32.6016 74.3594C31.3906 75.4531 29.3398 76 26.4492 76H8.22656C5.33594 76 3.26562 75.4531 2.01562 74.3594C0.804688 73.2266 0.199219 71.7617 0.199219 69.9648C0.199219 68.207 0.824219 66.7812 2.07422 65.6875C3.32422 64.5547 5.375 63.9883 8.22656 63.9883H10.1016V16.9961H8.22656C5.33594 16.9961 3.26562 16.4492 2.01562 15.3555C0.804688 14.2227 0.199219 12.7578 0.199219 10.9609C0.199219 9.16406 0.804688 7.71875 2.01562 6.625C3.26562 5.49219 5.33594 4.92578 8.22656 4.92578L35.4141 4.98438C43.8906 4.98438 50.4531 7.09375 55.1016 11.3125C59.7891 15.4922 62.1328 20.5898 62.1328 26.6055C62.1328 30.3555 61.0391 33.7734 58.8516 36.8594C56.6641 39.9062 53.3633 42.6211 48.9492 45.0039C51.4883 47.2305 54.2031 50.082 57.0938 53.5586C58.8906 55.7852 61.3125 59.2617 64.3594 63.9883C67.4062 63.9883 69.418 64.3008 70.3945 64.9258C72.1523 66.1367 73.0312 67.8359 73.0312 70.0234C73.0312 71.7812 72.4258 73.2266 71.2148 74.3594C70.0039 75.4531 67.9531 76 65.0625 76H58.207C48.4805 60.9609 40.4141 51.918 34.0078 48.8711H22.1133ZM22.1133 36.8594H31.4883C34.9648 36.8594 38.0703 36.332 40.8047 35.2773C44.4766 33.8711 46.9375 32.3867 48.1875 30.8242C49.4766 29.2617 50.1211 27.7188 50.1211 26.1953C50.1211 23.9297 48.9102 21.8398 46.4883 19.9258C44.0664 17.9727 40.5312 16.9961 35.8828 16.9961H22.1133V36.8594ZM137.777 50.3945C137.777 55.0039 136.488 59.4766 133.91 63.8125C131.371 68.1094 127.562 71.5469 122.484 74.125C117.445 76.6641 112.172 77.9336 106.664 77.9336C101.195 77.9336 95.9609 76.6836 90.9609 74.1836C85.9609 71.6445 82.1523 68.207 79.5352 63.8711C76.918 59.5352 75.6094 55.0039 75.6094 50.2773C75.6094 45.4727 76.9375 40.7656 79.5938 36.1562C82.25 31.5078 86.0586 27.8555 91.0195 25.1992C96.0195 22.543 101.234 21.2148 106.664 21.2148C112.133 21.2148 117.387 22.582 122.426 25.3164C127.504 28.0117 131.332 31.6641 133.91 36.2734C136.488 40.8438 137.777 45.5508 137.777 50.3945ZM125.766 50.4531C125.766 46.5859 124.379 43.0312 121.605 39.7891C117.816 35.4141 112.836 33.2266 106.664 33.2266C101.234 33.2266 96.7031 34.9648 93.0703 38.4414C89.4375 41.918 87.6211 45.9414 87.6211 50.5117C87.6211 54.2617 89.457 57.7773 93.1289 61.0586C96.8008 64.3008 101.312 65.9219 106.664 65.9219C112.055 65.9219 116.586 64.3008 120.258 61.0586C123.93 57.7773 125.766 54.2422 125.766 50.4531ZM206.215 0.00390625V63.9883H208.266C211.117 63.9883 213.168 64.5547 214.418 65.6875C215.668 66.7812 216.293 68.2266 216.293 70.0234C216.293 71.7812 215.668 73.2266 214.418 74.3594C213.207 75.4531 211.156 76 208.266 76H194.203V73.0703C191.469 74.6719 188.598 75.8828 185.59 76.7031C182.621 77.5234 179.535 77.9336 176.332 77.9336C167.309 77.9336 160.043 75.3359 154.535 70.1406C149.027 64.9062 146.273 58.4023 146.273 50.6289C146.273 42.5039 149.164 35.5703 154.945 29.8281C160.727 24.0859 167.777 21.2148 176.098 21.2148C179.223 21.2148 182.289 21.7031 185.297 22.6797C188.305 23.6172 191.273 25.043 194.203 26.957V12.0156H192.152C189.262 12.0156 187.191 11.4688 185.941 10.375C184.73 9.24219 184.125 7.79688 184.125 6.03906C184.125 4.24219 184.73 2.79688 185.941 1.70312C187.191 0.570313 189.262 0.00390625 192.152 0.00390625H206.215ZM194.203 50.9805C194.203 46.0195 192.465 41.8203 188.988 38.3828C185.512 34.9453 181.254 33.2266 176.215 33.2266C171.215 33.2266 166.977 34.9453 163.5 38.3828C160.023 41.8203 158.285 45.9609 158.285 50.8047C158.285 55.2188 159.848 58.8516 162.973 61.7031C166.098 64.5156 170.512 65.9219 176.215 65.9219C181.879 65.9219 186.293 64.5156 189.457 61.7031C192.621 58.8516 194.203 55.2773 194.203 50.9805ZM255.023 0.00390625V12.7188H240.727V0.00390625H255.023ZM256.664 22.7969V63.9883H271.078C273.969 63.9883 276.02 64.5547 277.23 65.6875C278.48 66.7812 279.105 68.2266 279.105 70.0234C279.105 71.7812 278.48 73.2266 277.23 74.3594C276.02 75.4531 273.969 76 271.078 76H230.238C227.348 76 225.277 75.4531 224.027 74.3594C222.816 73.2266 222.211 71.7617 222.211 69.9648C222.211 68.207 222.816 66.7812 224.027 65.6875C225.277 64.5547 227.348 63.9883 230.238 63.9883H244.652V34.8086H234.984C232.133 34.8086 230.082 34.2617 228.832 33.168C227.582 32.0352 226.957 30.5703 226.957 28.7734C226.957 27.0156 227.562 25.5898 228.773 24.4961C230.023 23.3633 232.094 22.7969 234.984 22.7969H256.664ZM310.629 22.7969V26.8398C312.816 24.9648 315.219 23.5586 317.836 22.6211C320.492 21.6836 323.363 21.2148 326.449 21.2148C333.559 21.2148 339.184 23.4219 343.324 27.8359C346.605 31.3516 348.246 35.9609 348.246 41.6641V63.9883C350.785 63.9883 352.66 64.5547 353.871 65.6875C355.082 66.7812 355.688 68.2266 355.688 70.0234C355.688 71.7812 355.062 73.2266 353.812 74.3594C352.602 75.4531 350.551 76 347.66 76H336.82C333.93 76 331.859 75.4531 330.609 74.3594C329.398 73.2266 328.793 71.7617 328.793 69.9648C328.793 68.207 329.398 66.7812 330.609 65.6875C331.82 64.5547 333.695 63.9883 336.234 63.9883V41.3125C336.234 38.6953 335.531 36.7812 334.125 35.5703C332.289 34.0078 329.535 33.2266 325.863 33.2266C323.09 33.2266 320.648 33.7734 318.539 34.8672C316.469 35.9219 313.832 38.1875 310.629 41.6641V63.9883C313.715 63.9883 315.707 64.2812 316.605 64.8672C318.52 66.0391 319.477 67.7578 319.477 70.0234C319.477 71.7812 318.852 73.2266 317.602 74.3594C316.391 75.4531 314.34 76 311.449 76H297.797C294.906 76 292.836 75.4531 291.586 74.3594C290.375 73.2266 289.77 71.7617 289.77 69.9648C289.77 67.7773 290.707 66.0781 292.582 64.8672C293.52 64.2812 295.531 63.9883 298.617 63.9883V34.8086C296.078 34.8086 294.203 34.2422 292.992 33.1094C291.781 31.9766 291.176 30.5312 291.176 28.7734C291.176 27.0156 291.781 25.5898 292.992 24.4961C294.242 23.3633 296.312 22.7969 299.203 22.7969H310.629Z"
                            fill="white" />
                    </svg>
                </div>
                <div className='flex justify-center w-full font-[700] text-white text-[12.8px] tracking-widest relative h-[20px]'>
                    {/* 旧文字 */}
                    <div className={`absolute w-full text-center transition-opacity duration-500 
            ${animationPhase >= 2 ? 'opacity-0' : 'opacity-100'}`}>
                        <span className={`relative inline-block ${animationPhase >= 1 ? style.strikeThrough : ''}`}>
                            Gen-1 RLHF V0.9 (Public Beta)
                        </span>
                    </div>

                    {/* 新文字 */}
                    <div className={`absolute w-full text-center transition-all duration-500
            ${animationPhase >= 2 ? style.titlefadeIn : style.titlefadeOut}`}>
                        Gen-1.5 V1.0
                    </div>
                </div>

                <div className='flex flex-col items-center gap-1 text-xxs sm:text-xs md:text-sm'
                    style={{
                        transform: !isMobile ? `translateY(${scrollLength ? -scrollLength + 'px' : '0'})` : 'translateY(0)',
                        opacity: `${1 - (scrollLength / 100)}`,
                    }}>
                    <span>{t('RODIN_HEADER_TIPS_1')}</span>
                    <span>{t('RODIN_HEADER_TIPS_2')}</span>
                </div>
            </div>
        </motion.div>
    );
};

const InputArea = React.forwardRef(({
    scrollLength,
    currentStatus,
    setUploading,
    checkAlpha,
    boundingBoxRef,
    uploadImageRaw,
    setUploadImgRaw,
    setCheckAlpha,
    setGenerateDisabled,
    initAlphaInfo,
    setInitAlphaInfo,
    setMeshParameters,
    meshParameters,
    setImageRecognitionInfo,
    imageRecognitionInfo
}, ref) => {
    const [showTextArea, setShowTextArea] = useState(false)
    const [prompt, setPrompt] = useState('')
    const logInfo = useRecoilValue(logInfoAtom);
    const modalObj = useRecoilValue(modalObjAtom);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const [uploadImgBlob, setUploadImgBlob] = useRecoilState(rodinUploadedImages);
    // const [compressImages, setCompressImages] = useState([]);
    const [fileDropHover, setFileDropHover] = useState(false);
    const [imagefile, setImagefile] = useState(false)
    const [generatedImageRaw, setGeneratedImageRaw] = useState(false);
    const [mouseEnterPrompt, setMouseEnterPrompt] = useState(false);
    // const [prompt2Img, setPrompt2Img] = useState(false);
    const fileInputRef = useRef(null);
    const textAreaRef = useRef(null);
    const textPromptRef = useRef(null);
    const tip = useTips();
    const [isLoading, setIsLoading] = useState(false);
    const [showBoundingTypeSelector, setShowBoundingTypeSelector] = useState(false);
    const [allowFaceEnhance, setAllowFaceEnhance] = useRecoilState(allowFaceEnhanceAtom);
    const [defalutFaceEnhance, setDefalutFaceEnhance] = useRecoilState(defaultFaceEnhanceAtom);
    const textAreaWrapperRef = useRef(null);
    const [procedPrompt, setProcessedPrompt] = useRecoilState(processedPrompt);
    const [alphaCheckArr, setAlphaCheckArr] = useState([])
    const { t } = useTranslation();
    const imgInputRef = useRef(null);
    const textInputRef = useRef(null);
    const [imgDropHover, setImgDropHover] = useState(false)
    const [driverAnimationFadeIn, setDriverAnimationFadeIn] = useState(false)
    const [driverTextAnimationFadeIn, setDriverTextAnimationFadeIn] = useState(false)
    const imgLengthRef = useRef(0)
    const setIsAnnotatorOpen = useSetRecoilState(isAnnotatorOpenAtom);
    const [deleteOver, setDeleteOver] = useState({
        status: false,
        callback: () => { }
    })


    useImperativeHandle(ref, () => ({
        handleCropFiles: handleCropFiles,
        handlerDeleteImg: handlerDeleteImg
    }))

    useEffect(() => {
        const SculptGLInfo = JSON.parse(sessionStorage.getItem('SculptGLInfo'))
        if (SculptGLInfo?.file && SculptGLInfo?.status === 'homepage' && SculptGLInfo?.type === 'condition') {
            const dbName = 'SculptGL';
            const storeName = 'SculptGL';
            initDB(dbName, storeName).then(async (db) => {
                const uploadImg = await db.get(storeName, 'uploadImg');
                if (uploadImg) {
                    setUploadImgBlob(uploadImg.uploadImgBlob)
                    setUploadImgRaw(uploadImg.uploadImageRaw)
                    setProcessedPrompt(uploadImg.procedPrompt)
                }
                db.delete(storeName, 'uploadImg');
            })
        }
    }, [])

    const initDB = async (dbName, storeName) => {
        const db = await openDB(dbName, 1, {
            upgrade(db) {
                db.createObjectStore(storeName);
            },
        });
        return db;
    }

    useEffect(() => {
        setGenerateDisabled(generatedImageRaw)
    }, [uploadImgBlob, generatedImageRaw])

    const preprocessAndReplaceImage = async (image, isFirstImage) => {
        try {
            // 在传给后端之前获取图片分辨率
            // 获取并打印图片信息
            const dimensions = await getImageDimensions(image);
            // console.log(`Image dimensions for ${image.name}:`, {
            //   width: dimensions.width,
            //   height: dimensions.height,
            //   aspectRatio: dimensions.aspectRatio,
            //   size: `${(image.size / 1024 / 1024).toFixed(2)}MB`
            // });

            let genPrompt = true;
            if (procedPrompt.length) {
                genPrompt = false;
            }
            const response = await rodinPreprocessImage({ generate_prompt: genPrompt, image });
            if (response?.data) {
                if (genPrompt) {
                    setProcessedPrompt(pre => [...pre, { name: image.name, prompt: response.data.prompt, height: response.data?.height }]);
                }
                const imageSrc = `data:image/png;base64,${response.data.processed_image}`;
                // 返回结果时包含额外信息
                setImageRecognitionInfo(pre => [...pre, {
                    imageSrc: imageSrc,
                    is_multiview: response.data.is_multiview,
                    num_multiview: response.data.num_multiview,
                    bbox: response.data.bbox,
                    dimensions: dimensions,
                    imageFile: image,
                    name: image.name,
                    prompt: response.data?.prompt,
                    // allow_face_enhance: response.data?.allow_face_enhance,
                    // default_face_enhance: response.data?.default_face_enhance,
                    processed_image: response.data?.processed_image,
                    height: response.data?.height,
                }]);

                return imageSrc

            } else {
                throw new Error('Image preprocessing failed.' + response);
            }
        } catch (error) {
            tip({
                content: t('TIP_ERR_NEWRODIN_PRE_PROCESS'),
                type: "error"
            })
            setUploadImgBlob([])
            setPrompt('')
            setUploadImgRaw([])
            Sentry.captureException(error)
            return false
        }
    };

    useEffect(() => {
        if (!modalObj.state) {
            setUploadImgBlob([])
            setUploadImgRaw([])
            setProcessedPrompt([])
        }
    }, [modalObj])

    const handlerTextClick = (e) => {
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        if (currentStatus) {
            return;
        }
        e.stopPropagation();
        setShowTextArea(true)
    }

    const closeTextArea = () => {
        setShowTextArea(false);
    };

    const handleClickOutside = (event) => {
        if (textAreaWrapperRef.current && !textAreaWrapperRef.current.contains(event.target)) {
            closeTextArea();
            setMouseEnterPrompt(false)
            // setPrompt('')
        }
    };

    const handleIpt = (ev) => {
        setPrompt(ev.currentTarget.value)
    };

    const handleFileInputChange = async (e) => {
        const files = [...e.target.files];
        trackEvent('Rodin - Mesh - Uploading Img: Start')
        // Filter out non-image files and limit the number of images
        const newImages = files.filter((file) => file.type.startsWith('image/')).slice(0, 5 - uploadImgBlob.length);
        if (newImages.length === 0) {
            tip({
                type: 'error',
                content: t('TIP_ERR_NEWRODIN_IMG_NO_VALID'),
            });
            return;
        }
        if (newImages.length > 5) {
            imgLengthRef.current = 5;
        } else {
            imgLengthRef.current = Math.min(imgLengthRef.current + newImages.length, 5);
        }
        tip({
            type: 'primary',
            content: t('TIP_PRIMARY_NEWRODIN_IMG_PROCESSED'),
        });

        const arr = await Promise.all(newImages.map((item) => isHasAlpha2(item)))
        setAlphaCheckArr(pre => [...pre, ...arr])
        rodinUploadCompressImg(newImages, arr).then(({ fileData }) => {
            const oversizedFiles = fileData.some((file) => file.file.size > 3 * 1024 * 1024);
            if (oversizedFiles) {
                trackEvent('Rodin - Mesh - Uploading Img: Failed Size')
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_NEWRODIN_UPLOAD_COMPRESS'),
                });
                return;
            }
            trackEvent('Rodin - Mesh - Uploading Img: Success')
            handlerFiles(fileData);
        })
    };

    useEffect(() => {
        if (deleteOver.status) {
            deleteOver.callback()
            setDeleteOver({
                status: false,
                callback: () => { }
            })
        }
    }, [deleteOver.status])

    const handleCropFiles = async (files, originalImgName) => {
        trackEvent('Rodin - Mesh - Crop Img: Start')
        const cb = async (files) => {
            // Filter out non-image files and limit the number of images
            const newImages = files.filter((file) => file.type.startsWith('image/')).slice(0, 5 - uploadImgBlob.length);
            if (newImages.length === 0) {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_NEWRODIN_IMG_NO_VALID'),
                });
                return;
            }
            if (newImages.length > 5) {
                imgLengthRef.current = 5;
            } else {
                imgLengthRef.current = Math.min(imgLengthRef.current + newImages.length, 5);
            }
            tip({
                type: 'primary',
                content: t('TIP_PRIMARY_NEWRODIN_IMG_PROCESSED'),
            });

            const arr = await Promise.all(newImages.map((item) => isHasAlpha2(item)))
            setAlphaCheckArr(pre => [...pre, ...arr])
            rodinUploadCompressImg(newImages, arr).then(({ fileData }) => {
                const oversizedFiles = fileData.some((file) => file.file.size > 3 * 1024 * 1024);
                if (oversizedFiles) {
                    trackEvent('Rodin - Mesh - Crop Img: Failed Size')
                    tip({
                        type: 'warning',
                        content: t('TIP_WRAN_NEWRODIN_UPLOAD_COMPRESS'),
                    });
                    return;
                }
                trackEvent('Rodin - Mesh - Crop Img: Success')
                handlerFiles(fileData);
            })
        }

        if (originalImgName) {
            const deleteImg = uploadImageRaw.find(item => item.fileName === originalImgName)
            if (deleteImg) {
                handlerDeleteImg(deleteImg, true)
            }
            setDeleteOver(pre => ({
                ...pre,
                callback: cb.bind(null, files)
            }))
        }

    };

    useEffect(() => {
        const hasTextGenerate = uploadImageRaw.some((item) => item.textGenerate)
        if (hasTextGenerate) {
            setInitAlphaInfo({
                initStatus: false,
                allAlpha: false
            })
        } else if (uploadImageRaw.length === 0) {
            setInitAlphaInfo({
                initStatus: true,
                allAlpha: false
            })
            setCheckAlpha(false)
        } else {
            const AllAlpha = uploadImageRaw.every((item) => {
                const index = alphaCheckArr.findIndex((i) => i.file === item.fileName)
                if (index > -1 && alphaCheckArr[index]?.isHasAlpha) {
                    return true
                }
                return false
            })

            const newInitAlphaInfo = { ...initAlphaInfo }
            if (newInitAlphaInfo.initStatus) {
                newInitAlphaInfo.initStatus = false
            }
            newInitAlphaInfo.allAlpha = AllAlpha
            setInitAlphaInfo(newInitAlphaInfo)
        }


    }, [uploadImageRaw])

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useLayoutEffect(() => {
        if (showTextArea) {
            textAreaRef.current.focus()
        }
    }, [showTextArea])

    const handlerFiles = async (fileList, textGenerate) => {
        let newImages
        if (textGenerate) {
            newImages = fileList
        } else {
            newImages = fileList.map((i) => i.file)
            // Add new filter to only allow png, jpg, jpeg images
            const unsupportedFormatFiles = newImages.some((file) => !['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].includes(file.type));
            if (unsupportedFormatFiles) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_IMG_NO_SUPPORT'),
                });
                return;
            }

            // const newImages = fileList.filter((file) => file.file.type.startsWith('image/'));
            if (uploadImageRaw.length + newImages.length > 5) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_NEWRODIN_IMG_LIMIT'),
                });
                return;
            }
            // Checking for duplicate files
            const duplicateFiles = newImages.some((newImage) => uploadImageRaw.some((blob) => blob.fileName === newImage.name));
            if (duplicateFiles) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_IMG_DUPLI_NAME'),
                });
                return;
            }
        }

        if (newImages.length) {
            newImages.map((item) => {
                isHasAlpha(item, transparentBg).then((result) => {
                    setUploadImgRaw((prev) => [...prev,
                    {
                        file: result.data,
                        fileName: item.name,
                        data: URL.createObjectURL(item),
                        combineData: result.combineData,
                        prompt: prompt,
                        textGenerate,
                        dataUrl: result.dataUrl,
                        isAlpha: result.isHasAlpha
                    }]);
                })
                setUploading((prev) => [...prev, item.name])
                imgNameArr = [...imgNameArr, item.name]
            })
            const processedImagesPromises = newImages.map((file, index) =>
                preprocessAndReplaceImage(file, index === 0).then(async (processedImageUrl) => {
                    if (processedImageUrl) {
                        const response = await fetch(processedImageUrl);
                        const processedBlob = await response.blob();
                        const processedFile = new File([processedBlob], file.name, { type: 'image/png' });
                        return {
                            fileName: file.name,
                            data: processedImageUrl,
                            file: processedFile,
                            isFirstImage: index === 0 // 标记是否为第一张图
                        };
                    } else {
                        return { fileName: file.name, data: false, file: false }
                    }
                })
            );
            Promise.all(processedImagesPromises).then((processedImages) => {
                processedImages.forEach(processedImage => {
                    if (processedImage && processedImage.fileName) {
                        // setCompressImages((prev) => [...prev, ...processedImages]);
                        if (processedImage.data) {
                            setUploadImgBlob((prev) => {
                                let filterArr = prev.filter((i) => i && i.data);
                                if (!filterArr.find((i) => i.fileName === processedImage.fileName)
                                    && imgNameArr.find((i) => i === processedImage.fileName)) {
                                    return [...filterArr, processedImage]
                                }
                                return [...filterArr]
                                // return [...filterArr, processedImage]
                            });
                        }

                        setUploading((prevUploading) =>
                            prevUploading.filter(name => name !== processedImage.fileName)
                        );

                    }
                });
            })
        }
    };

    const processDeleteImage = (imgArr, setImgArr, image) => {
        const newImages = [...imgArr];

        const indexInNewImages = newImages.findIndex((img) => img.fileName === image.fileName);

        if (indexInNewImages !== -1) {
            newImages.splice(indexInNewImages, 1);
        }
        setImgArr(newImages);
    }

    const handlerDeleteImg = async (image, ignoreStatus, e) => {
        if (currentStatus && !ignoreStatus) {
            return;
        }
        trackEvent('Rodin - Mesh - Delete Img: Start')
        const newalphaCheckArr = [...alphaCheckArr]
        const newProcessedPrompt = [...procedPrompt]
        const i = newalphaCheckArr.findIndex((item) => item.file === image.fileName)
        const j = newProcessedPrompt.findIndex((item) => item.name === image.fileName)
        if (i > -1) {
            newalphaCheckArr.splice(i, 1)
            setAlphaCheckArr(newalphaCheckArr)
        }
        if (j > -1) {
            newProcessedPrompt.splice(j, 1)
            setProcessedPrompt(newProcessedPrompt)
        }

        imgLengthRef.current = Math.max(imgLengthRef.current - 1, 0);
        // processDeleteImage(compressImages, setCompressImages, image)
        processDeleteImage(uploadImageRaw, setUploadImgRaw, image)
        processDeleteImage(uploadImgBlob, setUploadImgBlob, image)
        imgNameArr = imgNameArr.filter(i => i !== image.fileName)
        e?.stopPropagation();
        trackEvent('Rodin - Mesh - Delete Img: Success')
        setDeleteOver(pre => ({
            ...pre,
            status: true
        }))
    };

    const handlerDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFileDropHover(true);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFileDropHover(true);
    }

    const handlerDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFileDropHover(false);
    };

    const handleFileDrop = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        trackEvent('Rodin - Mesh - Uploading Img: Start')
        setFileDropHover(false);
        const files = [...event.dataTransfer.files];
        // Filter out non-image files and limit the number of images
        const newImages = files.filter((file) => file.type.startsWith('image/')).slice(0, 5 - uploadImgBlob.length);
        if (newImages.length === 0) {
            tip({
                type: 'error',
                content: t('TIP_ERR_NEWRODIN_IMG_NO_VALID'),
            });
            return;
        }
        if (newImages.length > 5) {
            imgLengthRef.current = 5;
        } else {
            imgLengthRef.current = Math.min(imgLengthRef.current + newImages.length, 5);
        }
        _czc.push(['_trackEvent', 'Rodin - Index', 'File Drop', 'Preview Component']);
        tip({
            type: 'primary',
            content: t('TIP_PRIMARY_NEWRODIN_IMG_PROCESSED'),
        });
        //检测图片是否包含 alpha 通道（透明度）
        const arr = await Promise.all(newImages.map((item) => isHasAlpha2(item)))
        setAlphaCheckArr(pre => [...pre, ...arr])
        rodinUploadCompressImg(newImages, arr).then(({ fileData }) => {
            const oversizedFiles = fileData.some((file) => file.file.size > 3 * 1024 * 1024);
            if (oversizedFiles) {
                trackEvent('Rodin - Mesh - Uploading Img: Failed Size')
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_NEWRODIN_UPLOAD_COMPRESS'),
                });
                return;
            }
            trackEvent('Rodin - Mesh - Uploading Img: Success')
            handlerFiles(fileData);
        })
    };

    const handleUploadIconClick = () => {
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        if (currentStatus || showTextArea) {
            return;
        }
        fileInputRef.current.value = '';
        fileInputRef.current.click();
    };

    const handlerPromptGenerate = async () => {
        if (uploadImageRaw.length >= 5) {
            tip({
                type: 'error',
                content: t('TIP_ERR_NEWRODIN_IMG_PROMPT_GEN'),
            });
            return;
        }

        setIsLoading(true);

        try {
            const res = await prompt2Img(prompt);
            trackEvent(`Rodin - Generate Image with Text: Start`, { prompt: prompt })
            if (res) {
                trackEvent(`Rodin - Generate Image with Text: Success`)
                const binaryData = res.data;
                const blob = new Blob([binaryData], { type: 'image/png' });
                const fileName = `generated-${Date.now()}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                setImagefile(file)
                const generatedImageRaw = {
                    fileName: file.name,
                    data: URL.createObjectURL(file),
                    file: file,
                    prompt: prompt,
                };
                setGeneratedImageRaw(generatedImageRaw)
            }
        } catch (e) {
            trackEvent(`Rodin - Generate Image with Text: Failed`)
            console.error(e);
            tip({
                type: 'error',
                content: t('TIP_WRAN_RODIN_IMAGE_GEN_FAILED'),
            })
            Sentry.captureException(e);
        } finally {
            closeTextArea()
            setMouseEnterPrompt(false)
            setIsLoading(false);
        }
    }

    const handlerInCorrect = () => {
        trackEvent('Rodin - Mesh - Image with Text InCorrect', { prompt: prompt })
        setGeneratedImageRaw(false)
        setPrompt('')
    }

    const handlerCorrect = async () => {
        if (uploadImgBlob.length !== uploadImageRaw.length) {
            // 不记得之前为什么写这个，但是这个逻辑有问题，所以先注释掉
            // setUploadImgBlob((prev) => prev.filter((file => file !== prev[prev.length - 1])));
        }
        trackEvent('Rodin - Mesh - Image with Text Correct', { prompt: prompt })
        setPrompt('')
        setGeneratedImageRaw(false)

        imgLengthRef.current = Math.min(imgLengthRef.current + 1, 5);

        await handlerFiles([imagefile], true)
    }

    const handlerOpenChangePrompt = () => {
        setMouseEnterPrompt(true)
    }

    useEffect(() => {
        if (mouseEnterPrompt) {
            textPromptRef.current.focus()
        }
    }, [mouseEnterPrompt])

    const handlerRefresh = async () => {
        trackEvent('Rodin - Mesh - Image with Text Refresh', { prompt: prompt })
        await handlerPromptGenerate()
    }

    // const handleMouseEnterTextInput = () => {
    //   setShowBoundingTypeSelector(true)
    // }

    // const handleMouseLeaveTextInput = (e) => {
    //   const left = e.target.getBoundingClientRect().left
    //   if (e.clientX < left || initStatus) return
    //   setShowBoundingTypeSelector(false)
    // }

    const handlerEnterInputArea = (e) => {
        if (textInputRef.current && textInputRef.current.contains(e.target)) {
            return
        }
        setDriverAnimationFadeIn(true)
    }

    const handlerLeaveInputArea = () => {
        setDriverAnimationFadeIn(false)
    }

    const handlerEnterTextInputArea = () => {
        setDriverAnimationFadeIn(false)
        setDriverTextAnimationFadeIn(true)
    }

    const handlerLeaveTextInputArea = () => {
        setDriverTextAnimationFadeIn(false)
    }

    const handleCropImage = async (targetName) => {
        const deleteImg = uploadImageRaw.find(item => item.fileName === targetName)
        if (deleteImg) {
            const dimensions = await getImageDimensions(deleteImg.file.file);
            const cropImage = {
                bbox: [],
                dimensions: dimensions,
                imageFile: deleteImg.file.file,
                name: deleteImg.fileName
            }
            // handlerDeleteImg(deleteImg)
            setIsAnnotatorOpen(pre => ({
                ...pre,
                name: targetName,
                status: true,
                isCrop: true,
                data: cropImage
            }))
        }




    }

    const driveAnimationOpen = ((imgLengthRef.current > 1) || showTextArea || generatedImageRaw) ? false : driverAnimationFadeIn

    return (
        <>
            <div
                className={`relative  flex gap-3 items-center justify-start max-w-full 
          ${driverAnimationFadeIn ? 'z-20' : ""}
          ${isMobile ? 'mt-10' : 'my-[40px] sm:mt-[60px] md:mt-[80px] lg:mt-[100px] xl:mt-[120px] 2xl:mt-[140px] 3xl:mt-[180px]'}`}
                onDrop={handleFileDrop}
                onDragOver={handleDragOver}
                onDragEnter={handlerDragEnter}
                onDragLeave={handlerDragLeave}
                id='newRodin-upload'
                style={{
                    // transform: `translateY(${scrollLength ? -scrollLength + 'px' : '0'})`,
                    opacity: `${1 - (scrollLength / 100)}`,
                }}
            >
                <ModelPresets
                    ref={boundingBoxRef}
                    imgDropHover={imgDropHover}
                    // initStatus={initStatus}
                    uploadImageRaw={uploadImageRaw}
                    uploadImgBlob={uploadImgBlob}
                    showTextArea={showTextArea}
                    generatedImageRaw={generatedImageRaw}
                    meshParameters={meshParameters}
                    showBoundingTypeSelector={showBoundingTypeSelector}
                    // setInitStatus={setInitStatus}
                    setMeshParameters={setMeshParameters}
                    setShowBoundingTypeSelector={setShowBoundingTypeSelector}
                />
                {/*  after:content-[''] after:absolute after:left-0 after:top-0 after:w-[50px] after:h-full after:translate-x-[-100%] ${showBoundingTypeSelector ? "" : ""} */}
                <div
                    // onMouseEnter={handleMouseEnterTextInput}
                    // onMouseLeave={handleMouseLeaveTextInput}
                    onMouseEnter={() => { setImgDropHover(true) }}
                    onMouseLeave={() => { setImgDropHover(false) }}
                    className={`flex items-center justify-start relative gap-2 flex-nowrap`}
                    ref={textAreaWrapperRef}
                >
                    <input
                        multiple
                        type="file"
                        key={Math.random}
                        ref={fileInputRef}
                        className='hidden'
                        onChange={handleFileInputChange}
                        accept=".jpg, .jpeg, .png"
                    />
                    {uploadImageRaw.map((image, index) => (
                        <div
                            key={index}
                            className='group/thumbnail relative w-[100px] h-[100px] sm:w-[128px] sm:h-[128px] md:w-[158px] md:h-[158px] bg-[rgba(0,0,0,0.2)] rounded-2xl cursor-pointer'
                        >
                            <img className='rounded-2xl w-full h-full object-cover' src={checkAlpha ? image.data : image.combineData} alt="thumbnail" />
                            <div className='w-full h-full absolute top-0 left-0 rounded-2xl bg-[rgba(102,102,102,0.3)]  backdrop-blur-[5px] opacity-0 invisible transition-300-ease p-2 group-hover/thumbnail:opacity-100 group-hover/thumbnail:visible flex justify-start items-start'>
                                <span className='w-full text-left font-medium text-white leading-4 '>{image.prompt || ''}</span>
                                <div className='absolute top-[10px] right-[10px] flex flex-col gap-2'>
                                    <div className={`group/delete relative w-[24px] h-[24px] rounded-full bg-[rgba(0,0,0,0.2)] flex justify-center items-center cursor-pointer transition-300-ease  hover:scale-125 ${currentStatus ? "cursor-not-allowed" : ''} `}>
                                        <span className=' opacity-0 group-hover/delete:opacity-100 transition-300-ease absolute-center block w-[16px] h-[16px]  rounded-[50%] blur-[5px] bg-[rgba(254,83,93,1)]  z-[-1]'></span>
                                        <img
                                            className={`w-[18px] h-[18px]`}
                                            src={deletePng} alt="deletePng"
                                            onClick={handlerDeleteImg.bind(null, image, index)} />
                                    </div>

                                    {/* <div className={`group/crop w-[24px] h-[24px] rounded-full bg-[rgba(0,0,0,0.2)] flex justify-center items-center cursor-pointer transition-300-ease  hover:scale-125 ${currentStatus ? "cursor-not-allowed" : ''}`}>
                    <span className=' opacity-0 group-hover/crop:opacity-100 transition-300-ease absolute-center block w-[16px] h-[16px]  rounded-[50%] blur-[5px] bg-[rgba(85,254,93,1)] z-[-1]'></span>
                    <img
                      className={` w-[18px] h-[18px]`}
                      src={cropIcon} alt="cropIcon"
                      onClick={handleCropImage.bind(null, image.fileName)} />
                  </div> */}
                                </div>
                            </div>
                        </div>
                    ))}
                    <div
                        ref={imgInputRef}
                        onMouseMove={handlerEnterInputArea}
                        onMouseLeave={handlerLeaveInputArea}
                        className=" w-[110px] h-[110px] sm:w-[138px] sm:h-[138px] md:w-[168px] md:h-[168px] bg-[rgba(0,0,0,0.2)] rounded-3xl relative">
                        <div
                            onClick={handleUploadIconClick}
                            className={`absolute top-0 left-0 w-full h-full rounded-3xl bg-[rgba(0,0,0,0.2)] flex flex-col items-center justify-center p-2 transition-300-ease  ${!showTextArea ? "opacity-100 z-[10] visible" : "opacity-0 z-[-100]"} ${fileDropHover ? "outline-dashed" : "outline-none"}`}>
                            <div className={`group/addIcon absolute left-1/2 top-[40%] transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] cursor-pointer  ${currentStatus ? "cursor-not-allowed" : ''}`}>
                                <span className="group-hover/addIcon:bg-white absolute-center bg-[#D9D9D9] rounded-[40px] transition duration-150 ease w-[38px] h-[4px] block"></span>
                                <span className="group-hover/addIcon:bg-white absolute-center bg-[#D9D9D9] rounded-[40px] transition duration-150 ease w-[4px] h-[38px] block"></span>
                            </div>
                            <div
                                ref={textInputRef}
                                onMouseMove={handlerEnterTextInputArea}
                                onMouseLeave={handlerLeaveTextInputArea}
                                className={`group/textBtn z-[1] relative opacity-100 hover:after:opacity-100 w-[88px] h-[24px] sm:w-[112px] sm:h-[28px] md:w-[132px] md:h-[32px] mt-auto select-none rounded-lg border-2 border-[#5c5c5c] transition-300-ease cursor-pointer after:absolute-center after:opacity-0 after:block after:w-[calc(100%+4px)] after:h-[calc(100%+4px)] after:bg-[#5c5c5c] after:rounded-lg after:transition-300-ease after:z-[-1] after:text-btn-animation ${currentStatus ? style.notouch : ''}`} onClick={handlerTextClick}>
                                <div className='relative flex-center bg-[rgba(0,0,0,0.8)] size-full rounded-[6px] gap-2 hover:shadow-[inset_0_0_14px_-1px_#8345FF] z-[0]'>
                                    <div>
                                        <svg className='w-[12px] h-[12px] sm:w-[17px] sm:h-[17px]' viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path className='fill-[#c4c4c4] group-hover/textBtn:fill-[url(#paint0_linear_30722_21860)] ' d="M3.35219 16.6095C2.88469 16.6095 2.41719 16.4313 2.06109 16.0756C1.34953 15.364 1.34938 14.2056 2.06094 13.4935L10.3161 5.239C11.0052 4.54947 12.2086 4.549 12.8981 5.239C13.243 5.58354 13.4327 6.04213 13.4327 6.52978C13.4327 7.01744 13.2428 7.47604 12.8978 7.82057L4.64312 16.0756C4.28719 16.4313 3.81969 16.6095 3.35219 16.6095ZM11.6072 5.66119C11.3753 5.66119 11.1572 5.75182 10.9933 5.91603L2.73812 14.1704C2.39984 14.5088 2.39969 15.0601 2.73812 15.3985C3.07656 15.737 3.62781 15.737 3.96625 15.3985L12.2209 7.14353C12.385 6.97947 12.4753 6.7615 12.4753 6.52963C12.4753 6.29775 12.3852 6.07994 12.2209 5.91572C12.0569 5.75182 11.8387 5.66119 11.6072 5.66119Z" fill="url(#paint0_linear_30722_21860)" />
                                            <path className='fill-[#c4c4c4] group-hover/textBtn:fill-[url(#paint1_linear_30722_21860)] ' d="M3.35219 16.6093C2.88469 16.6093 2.41719 16.4312 2.06109 16.0754C1.34953 15.3638 1.34938 14.2054 2.06094 13.4934L8.11453 7.43994L10.6966 10.022L4.64328 16.0754C4.28719 16.4312 3.81969 16.6093 3.35219 16.6093Z" fill="url(#paint1_linear_30722_21860)" />
                                            <path className='fill-[#c4c4c4] origin-center group-hover/textBtn:fill-[url(#paint2_linear_30722_21860)] group-hover/textBtn:star-animation-1' d="M13.9246 10.7826L14.3796 12.6154C14.3943 12.6748 14.4407 12.7212 14.5001 12.7359L16.3329 13.1909C16.5001 13.2325 16.5001 13.47 16.3329 13.5115L14.5001 13.9665C14.4407 13.9812 14.3943 14.0276 14.3796 14.087L13.9246 15.9198C13.883 16.087 13.6455 16.087 13.604 15.9198L13.149 14.087C13.1343 14.0276 13.0879 13.9812 13.0285 13.9665L11.1957 13.5115C11.0285 13.47 11.0285 13.2325 11.1957 13.1909L13.0285 12.7359C13.0879 12.7212 13.1343 12.6748 13.149 12.6154L13.604 10.7826C13.6455 10.6154 13.8832 10.6154 13.9246 10.7826Z" fill="url(#paint2_linear_30722_21860)" />
                                            <path className='fill-[#c4c4c4] origin-top-left group-hover/textBtn:fill-[url(#paint3_linear_30722_21860)] group-hover/textBtn:star-animation-2' d="M4.23791 0.186131L4.9136 2.90736C4.92436 2.95064 4.94671 2.99017 4.97824 3.0217C5.00977 3.05324 5.04931 3.07558 5.09259 3.08634L7.81393 3.762C8.06202 3.82364 8.06202 4.17643 7.81393 4.23806L5.09259 4.91373C5.04931 4.92448 5.00977 4.94683 4.97824 4.97836C4.94671 5.0099 4.92436 5.04942 4.9136 5.0927L4.23791 7.81393C4.17627 8.06202 3.82347 8.06202 3.76183 7.81393L3.0864 5.09219C3.07564 5.04891 3.05329 5.00938 3.02176 4.97785C2.99023 4.94631 2.95069 4.92397 2.90741 4.91321L0.186073 4.23755C-0.0620245 4.17591 -0.0620245 3.82312 0.186073 3.76149L2.90741 3.08582C2.95069 3.07507 2.99023 3.05272 3.02176 3.02119C3.05329 2.98965 3.07564 2.95012 3.0864 2.90685L3.76209 0.185615C3.82373 -0.0619575 4.17653 -0.0619574 4.23791 0.186131Z" fill="url(#paint3_linear_30722_21860)" />
                                            <path className='fill-[#c4c4c4] origin-[right_center] group-hover/textBtn:fill-[url(#paint4_linear_30722_21860)] group-hover/textBtn:star-animation-3' d="M15.0245 1.84043L15.2822 2.87824C15.2863 2.89476 15.2948 2.90984 15.3068 2.92187C15.3189 2.93391 15.334 2.94243 15.3505 2.94652L16.3883 3.20418C16.483 3.22762 16.483 3.36215 16.3883 3.38574L15.3505 3.6434C15.334 3.64749 15.3189 3.65602 15.3068 3.66805C15.2948 3.68008 15.2863 3.69516 15.2822 3.71168L15.0245 4.74949C15.0011 4.84418 14.8666 4.84418 14.843 4.74949L14.5853 3.71168C14.5812 3.69516 14.5727 3.68008 14.5607 3.66805C14.5486 3.65602 14.5335 3.64749 14.517 3.6434L13.4792 3.38574C13.3845 3.3623 13.3845 3.22777 13.4792 3.20418L14.517 2.94652C14.5335 2.94243 14.5486 2.93391 14.5607 2.92187C14.5727 2.90984 14.5812 2.89476 14.5853 2.87824L14.843 1.84043C14.8666 1.7459 15.0011 1.7459 15.0245 1.84043Z" fill="url(#paint4_linear_30722_21860)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_30722_21860" x1="7.48" y1="6.91635" x2="7.48" y2="19.9929" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#AA66FF" />
                                                    <stop offset="1" stopColor="#6FFFFF" stopOpacity="0.8" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_30722_21860" x1="6.11195" y1="9.13275" x2="6.11195" y2="19.2191" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#AA66FF" />
                                                    <stop offset="1" stopColor="#6FFFFF" stopOpacity="0.8" />
                                                </linearGradient>
                                                <linearGradient id="paint2_linear_30722_21860" x1="13.7643" y1="11.6519" x2="13.7643" y2="17.5787" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#AA66FF" />
                                                    <stop offset="1" stopColor="#6FFFFF" stopOpacity="0.8" />
                                                </linearGradient>
                                                <linearGradient id="paint3_linear_30722_21860" x1="4" y1="1.47692" x2="4" y2="10.2769" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#AA66FF" />
                                                    <stop offset="1" stopColor="#6FFFFF" stopOpacity="0.8" />
                                                </linearGradient>
                                                <linearGradient id="paint4_linear_30722_21860" x1="14.9337" y1="2.33279" x2="14.9337" y2="5.68886" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#AA66FF" />
                                                    <stop offset="1" stopColor="#6FFFFF" stopOpacity="0.8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <span className='text-normal text-center text-xxs sm:text-sm text-white leading-4 not-italic'>{t('RODIN_HEADER_TEXT_INPUT')}</span>
                                </div>
                                <div className='absolute bg-transparent w-[7px] sm:w-[12px] md:w-[14px] h-[26px] sm:h-[32px] md:h-[38px] right-[-7px] sm:right-[-12px] md:right-[-14px] top-0'></div>
                                <div className='absolute bg-transparent w-[7px] sm:w-[12px] md:w-[14px] h-[26px] sm:h-[32px] md:h-[38px] left-[-7px] sm:left-[-12px] md:left-[-14px] top-0'></div>
                                <div className='absolute bg-transparent  w-[88px] sm:w-[112px] md:w-[132px] h-[8px] left-0 bottom-[-8px]'></div>
                                <RodinTextDriverAnimation textOpen={driverTextAnimationFadeIn} />
                            </div>
                        </div>
                        <div className={`abosolute left-0 top-0 size-full transition-300-ease bg-[rgba(0,0,0,0.2)] rounded-3xl p-3 flex flex-col items-center gap-2 ${showTextArea ? "opacity-100 z-[100] visible" : "opacity-0 z-[-100] hidden"}`}>
                            <textarea onChange={handleIpt} ref={textAreaRef} value={prompt} className='px-1 focus:outline-none focus:border-none w-full flex-1 bg-transparent rounded-xl border-none text-[#ebebeb] text-left text-sm font-normal leading-4'></textarea>
                            {isLoading ? (
                                <button className={`w-[40px] h-[20px] sm:w-[48px] sm:h-[28px] md:w-[56px] md:h-[32px] border-[none] outline-[none] bg-[#7D3CFF] rounded-[60px] flex items-center justify-center cursor-not-allowed pointer-events-none text-white`}>
                                    <span className='loading-text-animation text-screen-sm'>&#9679;</span>
                                    <span className='loading-text-animation animation-delay-1 text-screen-sm'>&#9679;</span>
                                    <span className='loading-text-animation animation-delay-1 text-screen-sm'>&#9679;</span>
                                </button>
                            ) : (
                                <button
                                    className={`[border:none] [outline:none] w-[40px] h-[20px] sm:w-[48px] sm:h-[28px] md:w-[56px] md:h-[32px] bg-[rgb(125,60,255)] hover:bg-[#925BFF] text-[#FFFFFF] rounded-[60px] flex-center cursor-pointer [transition:background-color_0.3s_ease,_opacity_0.3s_ease] ${prompt ? "opacity-100 visible" : "opacity-0 invisible"}`}
                                    onClick={handlerPromptGenerate}
                                    disabled={isLoading}
                                >
                                    <img className='w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px]' src={correct} alt="correct" />
                                </button>
                            )}
                        </div>
                        <div className={`${style.prompt2ImgWrapper} ${generatedImageRaw ? style.show : style.hide}`}>
                            <img className={style.prompt2Img} src={generatedImageRaw?.data} alt="prompt2Img" />
                            <div className={style.promptHoverWrapper}>
                                <div className={style.infoIconWrapper} onClick={handlerOpenChangePrompt}>
                                    {/* <img src={info} alt="info" /> */}
                                    <LuPencilLine fontSize={16} color='#666' />
                                </div>
                                <div className='flex items-center gap-1 md:gap-2 relative'>
                                    <div className='cursor-pointer group/Incorrect w-[16px] h-[16px] sm:w-[24px] sm:h-[24px] md:w-[32px] md:h-[32px] relative' onClick={handlerInCorrect}>
                                        <div className='w-full h-full group-hover/Incorrect:blur-sm group-hover/Incorrect:after:content-[""] group-hover/Incorrect:after:absolute group-hover/Incorrect:after:w-[12px] group-hover/Incorrect:after:h-[12px] group-hover/Incorrect:after:rounded-[50%] group-hover/Incorrect:after:bg-[rgba(254,_85,_85,_1)] group-hover/Incorrect:after:[box-shadow:0_0_10px_4px_rgba(250,_82,_82,_1)] hover:bg-[rgba(0,0,0,0.15)] bg-[rgba(0,_0,_0,_0.3)] rounded-[50%] flex items-center justify-center cursor-pointer [transition:background-color_0.3s_ease] relative overflow-hidden' >
                                        </div>
                                        <img className='absolute-center w-[60%] h-[60%]' src={Incorrect} alt="Incorrect" />
                                    </div>
                                    {isLoading ? (
                                        <button className={`w-[40px] h-[20px] sm:w-[48px] sm:h-[28px] md:w-[56px] md:h-[32px] border-[none] outline-[none] bg-[#7D3CFF] rounded-[60px] flex items-center justify-center cursor-not-allowed pointer-events-none text-white`}>
                                            <span className='loading-text-animation text-screen-sm'>&#9679;</span>
                                            <span className='loading-text-animation animation-delay-1 text-screen-sm'>&#9679;</span>
                                            <span className='loading-text-animation animation-delay-1 text-screen-sm'>&#9679;</span>
                                        </button>
                                    ) : (
                                        <div className={`[border:none] [outline:none] w-[40px] h-[20px] sm:w-[48px] sm:h-[28px] md:w-[56px] md:h-[32px] bg-[rgb(125,60,255)] hover:bg-[#925BFF] text-[#FFFFFF] rounded-[60px] flex-center cursor-pointer [transition:background-color_0.3s_ease,_opacity_0.3s_ease] ${mouseEnterPrompt ? "invisible opacity-0" : ""}`} onClick={handlerRefresh}>
                                            <img className='w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px]' src={refresh} alt="refresh" />
                                        </div>
                                    )}
                                    <div onClick={handlerCorrect} className='cursor-pointer group/correct w-[16px] h-[16px] sm:w-[24px] sm:h-[24px] md:w-[32px] md:h-[32px]  relative'>
                                        <div className='w-full h-full group-hover/correct:blur-sm group-hover/correct:after:content-[""] group-hover/correct:after:absolute group-hover/correct:after:w-[12px] group-hover/correct:after:h-[12px] group-hover/correct:after:rounded-[50%] group-hover/correct:after:bg-[rgba(85,_254,_93,_1)] group-hover/correct:after:[box-shadow:0_0_10px_4px_rgba(87,_255,_95,_1)] group-hover/correct:bg-[rgba(0,0,0,0.15)] bg-[rgba(0,_0,_0,_0.3)] rounded-[50%] flex items-center justify-center cursor-pointer [transition:background-color_0.3s_ease] relative overflow-hidden'>
                                        </div>
                                        <img className='absolute-center w-[60%] h-[60%]' src={correct} alt="correct" />
                                    </div>
                                </div>
                            </div>
                            <div className={`${style.prompt2ImgTextAreaWrapper} ${mouseEnterPrompt ? style.show : style.hide}`}>
                                <textarea onChange={handleIpt} ref={textPromptRef} value={prompt} className='px-1 focus:outline-none focus:border-none w-full flex-1 bg-transparent rounded-xl border-none text-[#ebebeb] text-left text-sm font-normal leading-4'></textarea>
                                {isLoading ? (
                                    <button className={`w-[40px] h-[20px] sm:w-[48px] sm:h-[28px] md:w-[56px] md:h-[32px] border-[none] outline-[none] bg-[#7D3CFF] rounded-[60px] flex items-center justify-center cursor-not-allowed pointer-events-none text-white`}>
                                        <span className='loading-text-animation text-screen-sm'>&#9679;</span>
                                        <span className='loading-text-animation animation-delay-1 text-screen-sm'>&#9679;</span>
                                        <span className='loading-text-animation animation-delay-1 text-screen-sm'>&#9679;</span>
                                    </button>
                                ) : (
                                    <button
                                        className={`[border:none] [outline:none] w-[40px] h-[20px] sm:w-[48px] sm:h-[28px] md:w-[56px] md:h-[32px] bg-[rgb(125,60,255)] hover:bg-[#925BFF] text-[#FFFFFF] rounded-[60px] flex-center cursor-pointer [transition:background-color_0.3s_ease,_opacity_0.3s_ease] ${prompt ? "opacity-100 visible" : "opacity-0 invisible"}`}
                                        onClick={handlerPromptGenerate}
                                        disabled={isLoading}
                                    >
                                        <img className='w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px]' src={correct} alt="correct" />
                                    </button>
                                )}
                            </div>
                        </div>
                        {!isPrerenderUserAgent() && (
                            <RodinDriverAnimation open={driveAnimationOpen} />
                        )}
                    </div>
                </div>
            </div>

        </>

    )
})

const GenrateArea = React.forwardRef(({
    scrollLength,
    setMeshParameters,
    meshParameters,
    currentStatus,
    checkAlpha,
    setCheckAlpha,
    setCurrentStatus,
    uploading,
    boundingBoxRef,
    uploadImageRaw,
    generateDisabled,
    initAlphaInfo,
    imageRecognitionInfo,
    inputAreaRef,
    setImageRecognitionInfo,
    handleShowPromotion
}, ref) => {
    const setModalObj = useSetRecoilState(modalObjAtom);
    const setControllerInfo = useSetRecoilState(controllerInfoAtom);
    const tip = useTips();
    // const [currentWeight,] = useRecoilState(rodinInitWeightAtom)
    const [uploadImgBlob, setUploadImgBlob] = useRecoilState(rodinUploadedImages);
    const setGenPipeline = useSetRecoilState(rodinGenPipeline);
    const procedPrompt = useRecoilValue(processedPrompt);
    // const [weightInitShow, setWeightInitShow] = useState(false)
    const [currentWeight, setCurrentWeight] = useRecoilState(rodinInitWeightAtom)
    const [multiImgTipBox, setMultiImgTipBox] = useState(false)
    const [homePagePrivate, setHomePagePrivate] = useState((localStorage.getItem('homePagePrivate') || '') === 'true');

    const changeHomePagePrivate = useCallback((privateMode) => {
        if (typeof privateMode === 'function') {
            setHomePagePrivate((prev) => {
                localStorage.setItem('homePagePrivate', privateMode(prev))
                return privateMode(prev)
            })
        } else {
            localStorage.setItem('homePagePrivate', privateMode)
            setHomePagePrivate(privateMode)
        }
    }, [])
    const userPermission = useRecoilValue(userPermissionAtom);
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
    const homePagePrivateRef = useRef(null)
    const taskTimeRef = useRef(null)
    const taskTimeValueRef = useRef(0)
    const setIsRodinGenerating = useSetRecoilState(isRodinGeneratingAtom)
    const [allowFaceEnhance, setAllowFaceEnhance] = useRecoilState(allowFaceEnhanceAtom);
    const [defalutFaceEnhance, setDefalutFaceEnhance] = useRecoilState(defaultFaceEnhanceAtom);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const logInfo = useRecoilValue(logInfoAtom);
    const setTaskDetail = useSetRecoilState(taskDetailAtom);
    const { connect, query, disconnect, onMessage, setReconnectAttempts } = useWebSocket('/scheduler_socket');
    const cardsType = useRecoilValue(cardsTypeAtom);
    const setCards = useSetRecoilState(cardsAtom);
    const { t } = useTranslation();
    const [currentWallet, setCurrentWallet] = useState({
        bg: false,
        wallet: 'personal',
    })
    const [showMultibox, setShowMultibox] = useState(false)
    const [isQueued, setIsQueued] = useState(false)
    const [isAnnotatorOpen, setIsAnnotatorOpen] = useRecoilState(isAnnotatorOpenAtom);
    const { isCreatorOrAbove } = useContext(PermissionContext);
    const StateMap = {
        'PREPARING': t('BUTTON_PREPARING'),
        'GENERATING': t('BUTTON_GENERATETING'),
        'UPLOADING': t('BUTTON_UPLOADING'),
        'QUEUING': t('BUTTON_QUEUING')
    }
    const { isYearly, isUnlimited } = useContext(PermissionContext);


    useImperativeHandle(ref, () => ({
        singleImgCroppingGenerate: singleImgCroppingGenerate,
        closeAnnotator: closeAnnotator
    }))

    const handleUpload = async (trigger = false) => {
        const generateAndCheckProgress = async (trigger) => {
            try {

                setShowMultibox(false)
                // 检查上传图片是否完成
                if (uploadImgBlob.length !== uploadImageRaw.length) {
                    setCurrentStatus('UPLOADING')
                    return
                }

                let firstPrompt, promptFlag = procedPrompt.length && procedPrompt.findIndex((item) => item.name === uploadImgBlob[0].fileName)
                // const allow = allowFaceEnhance.filter((item) => item.name === imgNameArr[0])
                // const defalut = defalutFaceEnhance.filter((item) => item.name === imgNameArr[0])
                let imageRecognitionTrrigger = imageRecognitionInfo.filter((item) => item.name === imgNameArr[0])[0]

                // 获取 prompt
                try {
                    if (promptFlag === -1) {
                        const response = await rodinPreprocessImage({ generate_prompt: true, image: uploadImgBlob[0].file });
                        if (response.data) {
                            firstPrompt = response.data.prompt
                            imageRecognitionTrrigger = {
                                is_multiview: response.data.is_multiview,
                                num_multiview: response.data.num_multiview,
                                bbox: response.data.bbox
                            }
                        } else {
                            throw new Error('Image preprocessing failed.' + response);
                        }
                    } else {
                        firstPrompt = procedPrompt[promptFlag]?.prompt
                    }
                } catch (error) {
                    resetStates()
                    tip({
                        type: 'error',
                        presetText: 'ERROR',
                        content: t('TIP_ERR_GENERATING_PROMPT'),
                    });
                    Sentry.captureException(error);
                    console.error('Error while generating prompt:', error, procedPrompt, promptFlag);
                    firstPrompt = "Please provide the prompt..."
                }

                // 处理多物体识别
                // if (uploadImgBlob.length === 1 && imageRecognitionTrrigger?.is_multiview && !trigger) {
                //   setIsAnnotatorOpen(pre => ({
                //     ...pre,
                //     name: imageRecognitionTrrigger.name,
                //     status: true,
                //     isCrop: false
                //   }))
                //   setCurrentStatus('GENERATE')
                //   return
                // }

                imgNameArr = []
                setCurrentStatus("PREPARING")
                setIsRodinGenerating(true)
                if (taskTimeRef.current) {
                    clearInterval(taskTimeRef.current)
                }
                taskTimeValueRef.current = 0

                try {

                    // 构建参数
                    const params = {
                        prompt: firstPrompt || 'Please enter your prompt here...',
                        group_uuid: null,
                        settings: {
                            view_weights: RODINWEIGHTS[currentWeight][uploadImgBlob.length - 1],
                            condition_mode: ['concat', 'fuse'][currentWeight],
                            image_label: new Array(uploadImgBlob.length).fill("?"),
                            height: procedPrompt[promptFlag]?.height || 100,
                            // allow_face_enhance: allow[0]?.value,
                            // default_face_enhance: defalut[0]?.value,
                            sharp_bias: 2.5
                        },
                        // 不勾选传抠好的图,勾选了传原图
                        images: (checkAlpha && initAlphaInfo.allAlpha) ? uploadImageRaw.map((item) => item.file) : uploadImgBlob
                    }

                    // if (checkAlpha && initAlphaInfo.allAlpha) {
                    //   downloadImages(uploadImageRaw.map((item) => item.file.file))
                    // } else {
                    //   downloadImages(uploadImgBlob.map((item) => item.file))
                    // }

                    // 处理 prompt
                    const firstSentenceEndIndex = params.prompt.indexOf('.');
                    const restOfText = params.prompt.substring(firstSentenceEndIndex + 1).trim();
                    const restOfTextLower = restOfText?.toLowerCase();
                    if (restOfTextLower.indexOf("character") !== -1) {
                        params.settings.image_mode = 'recon'
                    }

                    // 处理网格参数
                    let bbox_condition = meshParameters['bbox'].confirmed ? meshParameters['bbox'].params : null;
                    let voxel_condition = meshParameters['voxel'].confirmed ? pos2Base64(meshParameters['voxel'].params) : null;
                    let voxel_condition_cfg = meshParameters['voxel'].voxel_condition_cfg;
                    let voxel_condition_weight = +meshParameters['voxel'].voxel_condition_weight;
                    let pcd_condition = meshParameters['pointCloud'].confirmed ? meshParameters['pointCloud'].params : null;
                    let pcd_condition_uncertainty = +meshParameters['pointCloud'].pcd_condition_uncertainty;

                    if (bbox_condition) params.settings.bbox_condition = bbox_condition;
                    if (voxel_condition) {
                        params.settings.voxel_condition = voxel_condition;
                        params.settings.voxel_condition_cfg = voxel_condition_cfg;
                        params.settings.voxel_condition_weight = voxel_condition_weight;
                    }
                    if (pcd_condition) {
                        params.settings.pcd_condition = pcd_condition;
                        params.settings.pcd_condition_uncertainty = pcd_condition_uncertainty;
                    }

                    // 处理群组权限
                    if (userPermission.chatavatar_tab_group && currentWallet.wallet === 'group') {
                        params.group_uuid = localStorage.getItem('group_uuid')
                    }

                    const res = await rodinMesh(params);
                    trackEvent(`Rodin - Mesh - Generate: Start`, params)
                    const subKey = res?.data?.job?.subscription_key
                    const jobid = res?.data?.job?.uuids[0]

                    if (res?.data?.error || !subKey) {
                        resetStates();
                        return;
                    }

                    // 处理 alpha 通道
                    if (checkAlpha && initAlphaInfo.allAlpha) {
                        const combine = uploadImageRaw.map((item) => ({
                            ...item.file,
                            data: item.dataUrl
                        }));
                        setUploadImgBlob(combine);
                    }

                    // 设置生成管道
                    const uuid = res.data.uuid;
                    resetGenPipeline(uuid, setGenPipeline);

                    if (homePagePrivate) {
                        await homePagePrivateRef.current.setPrivateDelay(uuid);
                    }

                    const rep = await getTaskDetail(uuid);
                    if (!rep?.data?.type) {
                        throw new Error('getTaskDetail error');
                    }

                    setTaskDetail(rep.data);
                    setCurrentStatus("GENERATING");

                    // 连接 WebSocket
                    connect(subKey);
                    const interval = setInterval(() => {
                        query(jobid);
                    }, 10000);
                    taskTimeRef.current = setInterval(() => {
                        taskTimeValueRef.current = taskTimeValueRef.current + 1
                    }, 1000)
                    let hasStartedQueued = false;
                    setReconnectAttempts(0);

                    onMessage('message', async (data, res) => {
                        if (res?.jobStatus === 'Queued') {
                            if (!isQueued) {
                                trackEvent(`Rodin - Mesh - Generate: Join Queue`, { queueTime: taskTimeValueRef.current }, uuid)
                            }
                            ReactGA.event(
                                {
                                    category: 'hyper3d',
                                    action: 'queued_geometry_sdf',
                                    label: 'pressure_tracking'
                                }
                            )
                            setCurrentStatus("QUEUING")
                            setIsQueued(true);
                            hasStartedQueued = true;
                        }
                        else if (res?.jobStatus === 'Running') {
                            setCurrentStatus("GENERATING")
                        }
                        else if (res?.jobStatus === 'Succeeded') {
                            trackEvent(`Rodin - Mesh - Generate: Succeeded`, { credits: 0, executionTime: taskTimeValueRef.current }, uuid)
                            handleSuccess({
                                interval,
                                voxel_condition,
                                bbox_condition,
                                pcd_condition,
                                pcd_condition_uncertainty,
                                voxel_condition_weight,
                                voxel_condition_cfg,
                                cardsType,
                                disconnect
                            });
                            // pushHistoryState(uuid, 'rodin')
                            if (taskTimeRef.current) {
                                clearInterval(taskTimeRef.current)
                            }
                            taskTimeValueRef.current = 0
                        }
                        else if (res?.jobStatus === 'Canceled') {
                            trackEvent(`Rodin - Mesh - Generate: Canceled`, false, uuid)
                            ReactGA.event(
                                {
                                    category: 'hyper3d',
                                    action: 'canceled_geometry_sdf',
                                    label: 'pressure_tracking'
                                }
                            )
                            handleCanceled(interval, disconnect);
                            if (taskTimeRef.current) {
                                clearInterval(taskTimeRef.current)
                            }
                            taskTimeValueRef.current = 0
                        }
                    });

                } catch (error) {
                    trackEvent(`Rodin - Mesh - Generate: Failed`)
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'failed_geometry_sdf',
                            label: 'pressure_tracking'
                        }
                    )
                    console.error('Error while generating:', error);
                    Sentry.captureException(error);
                    resetStates();
                }

            } catch (error) {
                tip({
                    type: 'error',
                    presetText: 'ERROR',
                    content: `${t('TIP_ERR_WHILE_GEN')} ${error}`,
                    yes: () => close(),
                    no: (f) => f,
                });
                resetStates();
            }
        };

        await generateAndCheckProgress(trigger);
    }

    const resetStates = () => {
        // setAllowFaceEnhance([]);
        // setDefalutFaceEnhance([]);
        setIsRodinGenerating(false);
        setImageRecognitionInfo([])
        setIsAnnotatorOpen(pre => ({
            ...pre,
            name: '',
            status: false,
            isCrop: false
        }));
        setCurrentStatus(false);
        setIsQueued(false);
    }

    const handleSuccess = async ({
        interval,
        voxel_condition,
        bbox_condition,
        pcd_condition,
        pcd_condition_uncertainty,
        voxel_condition_weight,
        voxel_condition_cfg,
        cardsType,
        disconnect
    }) => {
        setIsQueued(false);
        clearInterval(interval);

        setTimeout(async () => {
            resetStates();
            setModalObj((pre) => ({
                ...pre,
                state: true,
                type: 'Rodin',
                origin: 'generate'
            }));

            setControllerInfo({
                voxel_condition,
                bbox_condition,
                pcd_condition,
                pcd_condition_uncertainty,
                voxel_condition_weight,
                voxel_condition_cfg
            });

            setMeshParameters(defaultMeshParameters);

            if (['Mine', 'Group'].includes(cardsType)) {
                try {
                    const rep = await getCards({
                        type: cardsType,
                        page_num: 0,
                        task_type: "Rodin",
                        user_type: cardsType === 'Mine' ? 'All' : null
                    });
                    if (rep?.data) {
                        setCards(rep.data);
                    } else {
                        throw Error('Error getting cards' + rep);
                    }
                } catch (error) {
                    console.error('Error getting cards:', error);
                    Sentry.captureException(error);
                }
            }

            disconnect();
        }, 1500);
    }

    const handleCanceled = (interval, disconnect) => {
        setIsQueued(false);
        clearInterval(interval);

        tip({
            type: 'warning',
            content: t("TIP_WRAN_ISSUES_OCCURRED")
        });

        resetStates();
        disconnect();
    }

    function downloadImages(files) {
        files.forEach((file, index) => {
            const url = URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = file.name || `image-${index + 1}.png`; // 设置下载文件名
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url); // 释放 URL 对象
        });
    }

    const closeAnnotator = (isDelete = false) => {
        if (isDelete) {
            let imageRecognitionTrrigger = imageRecognitionInfo.filter((item) => item.name === imgNameArr[0])[0]
            const deleteImg = uploadImageRaw.find(item => item.fileName === imageRecognitionTrrigger.name)
            if (deleteImg) {
                inputAreaRef.current && (inputAreaRef.current.handlerDeleteImg(deleteImg, true))
            }
        }
        setIsRodinGenerating(false)
        setIsAnnotatorOpen(pre => ({
            ...pre,
            name: '',
            status: false,
            isCrop: false
        }))
        setCurrentStatus(false)
    }

    const pushHistoryState = (taskUuid, taskType) => {
        const url = new URL(window.location.href)
        url.pathname = `/${taskType}/${taskUuid}`;
        window.history.pushState(null, null, url);
    }

    const singleImgCroppingGenerate = async (props) => {
        // console.log('singleImgCroppingGenerate', props);
        let { imagesData, prompt, height, condition_mode, weightIndex } = props
        const allAlpha = checkAlpha && imagesData.every((item) => item.isHasAlpha)
        const processedFiles = imagesData.map((item) => ({ file: item.preprocessFile }))
        const combinedFiles = imagesData.map((item) => ({ file: item.compressedfile }))
        // downloadImages(imagesData.map((item) => item.compressedfile))
        // downloadImages(imagesData.map((item) => item.preprocessFile))
        if (taskTimeRef.current) {
            clearInterval(taskTimeRef.current)
        }
        taskTimeValueRef.current = 0
        try {
            const params = {
                prompt: prompt,
                group_uuid: null,
                settings: {
                    view_weights: RODINWEIGHTS[weightIndex][processedFiles.length - 1],
                    condition_mode: condition_mode,
                    image_label: new Array(processedFiles.length).fill("?"),
                    height: height,
                    // allow_face_enhance: allow_face_enhance,
                    // default_face_enhance: default_face_enhance,
                    sharp_bias: 2.5
                },
                images: allAlpha ? combinedFiles : processedFiles
            }

            // handle when prompt does not exist
            if (!prompt) {
                prompt = 'Please enter your prompt here...'
            }

            const firstSentenceEndIndex = prompt.indexOf('.');
            const restOfText = prompt.substring(firstSentenceEndIndex + 1).trim();
            const restOfTextLower = restOfText?.toLowerCase();
            if (restOfTextLower.indexOf("character") !== -1) {
                params.settings.image_mode = 'recon'
            }
            let bbox_condition = null
            let voxel_condition = null
            let voxel_condition_cfg = meshParameters['voxel'].voxel_condition_cfg
            let voxel_condition_weight = +meshParameters['voxel'].voxel_condition_weight
            let pcd_condition = null
            let pcd_condition_uncertainty = +meshParameters['pointCloud'].pcd_condition_uncertainty


            if (meshParameters['bbox'].confirmed) {
                bbox_condition = meshParameters['bbox'].params
                params.settings.bbox_condition = bbox_condition
            }

            if (meshParameters['voxel'].confirmed) {
                voxel_condition = pos2Base64(meshParameters['voxel'].params)
                params.settings.voxel_condition = voxel_condition
                params.settings.voxel_condition_cfg = voxel_condition_cfg
                params.settings.voxel_condition_weight = voxel_condition_weight
            }

            if (meshParameters['pointCloud'].confirmed) {
                pcd_condition = meshParameters['pointCloud'].params
                params.settings.pcd_condition = pcd_condition
                params.settings.pcd_condition_uncertainty = pcd_condition_uncertainty

            }

            if (userPermission.chatavatar_tab_group && currentWallet.wallet === 'group') {
                params.group_uuid = localStorage.getItem('group_uuid')
            }

            const res = await rodinMesh(params);
            trackEvent(`Rodin - Mesh - Generate: Start`, params)
            const subKey = res?.data?.job?.subscription_key
            const jobid = res?.data?.job?.uuids[0]
            if (res?.data?.error || !subKey) {
                setIsRodinGenerating(false)
                setCurrentStatus(null)
                // setAllowFaceEnhance([])
                // setDefalutFaceEnhance([])
                return
            }

            // 直接打开的时候的图片信息
            const blobs = imagesData.map((item) => ({
                data: allAlpha ? item.combineDataBase64 : item.preprocessImageSrc,
                file: allAlpha ? item.combineFile : item.preprocessFile,
                fileName: item.name
            }));
            setUploadImgBlob(blobs);

            const uuid = res.data.uuid;
            resetGenPipeline(uuid, setGenPipeline);
            if (homePagePrivate) {
                await homePagePrivateRef.current.setPrivateDelay(uuid)
            }
            const rep = await getTaskDetail(uuid);
            if (!rep?.data?.type) {
                throw new Error('getTaskDetail error');
            }
            // setAllowFaceEnhance([])
            // setDefalutFaceEnhance([])
            setTaskDetail(rep.data);
            setCurrentStatus("GENERATING")
            // await checkProgressUntilDone(uuid);
            // setIsRodinGenerating(false)
            connect(subKey)
            const interval = setInterval(() => {
                query(jobid)
            }, 10000)
            taskTimeRef.current = setInterval(() => {
                taskTimeValueRef.current = taskTimeValueRef.current + 1
            }, 1000)
            let hasStartedQueued = false
            setReconnectAttempts(0)
            onMessage('message', async (data, res) => {
                if (res?.jobStatus === 'Queued') {
                    if (!isQueued) {
                        trackEvent(`Rodin - Mesh - Generate: Join Queue`, { queueTime: taskTimeValueRef.current }, uuid)
                    }
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'queued_geometry_sdf',
                            label: 'pressure_tracking'
                        }
                    )
                    setIsQueued(true)
                    if (!hasStartedQueued) {
                        hasStartedQueued = true
                    }
                }
                if (res?.jobStatus === 'Succeeded') {
                    trackEvent(`Rodin - Mesh - Generate: Succeeded`, { credits: 0, executionTime: taskTimeValueRef.current }, uuid)
                    handleSuccess({
                        interval,
                        voxel_condition,
                        bbox_condition,
                        pcd_condition,
                        pcd_condition_uncertainty,
                        voxel_condition_weight,
                        voxel_condition_cfg,
                        cardsType,
                        disconnect
                    });
                    // pushHistoryState(uuid, 'rodin')
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                }
                // If confirm failed
                if (res?.jobStatus === 'Canceled') {
                    trackEvent(`Rodin - Mesh - Generate: Canceled`, false, uuid)
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'canceled_geometry_sdf',
                            label: 'pressure_tracking'
                        }
                    )
                    handleCanceled(interval, disconnect);
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                }
            })
        } catch (error) {
            trackEvent(`Rodin - Mesh - Generate: Failed`)
            ReactGA.event(
                {
                    category: 'hyper3d',
                    action: 'failed_geometry_sdf',
                    label: 'pressure_tracking'
                }
            )
            console.error('Error while generating:', error);
            Sentry.captureException(error)
            resetStates();
        }
    }

    useEffect(() => {
        if (currentStatus === "UPLOADING" && !uploading.length) {
            handleUpload().then(r => console.info("Uploaded"))
        }
    }, [uploading.length, currentStatus, uploadImgBlob.length, uploadImageRaw.length]);

    const handleRodinGenerate = async (e) => {
        if (!logInfo) {
            setShowLogin(true)
            return
        }

        trackEvent('Rodin - Mesh - Generate: Click')

        if (homePagePrivateRef?.current?.selfRef.current && homePagePrivateRef?.current?.selfRef.current.contains(e.target)) {
            return
        }
        if (boundingBoxRef?.current && boundingBoxRef.current.mustConfirmStatus) {
            tip({
                type: 'warning',
                content: t('TIP_WRAN_CONFIRM_MODEL'),
            });
            return
        }

        if (!isCreatorOrAbove() && uploadImageRaw.length > 1) {
            setMultiImgTipBox(true)
            setTimeout(() => {
                setMultiImgTipBox(false)
            }, 5000);
            return
        }

        // if (weightWrapperRef.current && weightWrapperRef.current.contains(e.target)) {
        //   return
        // }

        if (uploadImageRaw.length === 0 || generateDisabled) {
            tip({
                type: 'error',
                content: t('TIP_ERR_NEWRODIN_IMG_LEAST_ONE'),
            });
            return;
        }

        if (currentStatus) {
            return
        }

        if (uploadImageRaw.length > 1) {
            setShowMultibox(true)
            return
        }

        setIsRodinGenerating(true)
        setCurrentStatus("UPLOADING")
        /**
         * 新用户促销
         * 1. 非年订阅才显示
         * 2. Mine中[自己生成]且Liked的 asset  >= Mine 中[自己生成]的 Total asset % 3  + 3
         */
        // const forbidFlag = isYearly() || isUnlimited()
        // if (!forbidFlag) {
        //   const [page1, page2, page3] = await Promise.all([
        //     getCards({ type: 'Mine', page_num: 0, user_type: 'All', task_type: 'Rodin', needCancel: false }),
        //     getCards({ type: 'Mine', page_num: 1, user_type: 'All', task_type: 'Rodin', needCancel: false }),
        //     getCards({ type: 'Mine', page_num: 2, user_type: 'All', task_type: 'Rodin', needCancel: false }),
        //   ])

        //   const hash = (str) => {
        //     let total = 0;
        //     for (let i = 0; i < str.length; i++) {
        //       // 使用质数31来减少碰撞
        //       total = ((total << 5) - total) + str.charCodeAt(i);
        //       total = total & total; // 转换为32位整数
        //     }
        //     total = Math.abs(total);
        //     return total % 3;
        //   }
        //   // also item.time > 2025-01-20T10:16:03.385Z
        //   const totalMineAssets = [...page1.data, ...page2.data, ...page3.data].filter(item =>
        //       item.author?.user_uuid === logInfo.user_uuid &&
        //       new Date(item.time) > new Date('2025-01-20T10:16:03.385Z')
        //   );
        //   const likedMineAssets = totalMineAssets.filter(item => item.is_like)

        //   // const triggerConditions = likedMineAssets?.length >= hash(logInfo.user_uuid) + 3
        //   const triggerConditions = likedMineAssets?.length > 2 // after second download
        //   const stored = localStorage.getItem('newUserPromotionTimeLeft');
        //   const currentUUID = logInfo.user_uuid;
        //   const hasUserPromotion = stored ? JSON.parse(stored)[currentUUID] : null;

        //   if (!hasUserPromotion && triggerConditions) {
        //     // 1/3 doesn't have any promotion
        //     if (hash(logInfo.user_uuid) === 1) {
        //       trackEvent('Promotion - Targeted 50% off: Ignored')
        //     } else {
        //       // trackEvent(`Promotion - Targeted 50% off: Triggered - ${(hash(logInfo.user_uuid) + 3).toString()}`)
        //       trackEvent(`Promotion - Targeted 50% off: Triggered - 2`)
        //       handleShowPromotion()
        //     }
        //   }
        // }
    }

    const handlerClickWeight = (index) => {
        setCurrentWeight(index)
        setIsRodinGenerating(true)
        setCurrentStatus("UPLOADING")
    }

    const handleOpenSub = () => {
        trackEvent('Subscribe - Page: Open')
        setShowSubscribe(true)
        setMultiImgTipBox(false)
    }

    const handleCheckBox = (e) => {
        e.stopPropagation()
        if (currentStatus) {
            return
        }
        setCheckAlpha(pre => !pre)
    }

    const isMobile = checkMobile()
    return (
        <div
            className={`${style.generateWrapper} ${currentStatus ? style.gennerating : ""}`}
            style={{
                opacity: `${1 - (scrollLength / 100)}`,
                justifySelf: "center",
            }}
            onClick={handleRodinGenerate}>

            <Restricted to="wallet.index.rodin.view">
                {userPermission.chatavatar_tab_group && !isMobile && (
                    <RodinWallet
                        currentStatus={currentStatus}
                        setCurrentWallet={setCurrentWallet}
                        currentWallet={currentWallet} />
                )}
            </Restricted>
            <Restricted to="private.index.rodin.view">
                <HomePagePrivate
                    ref={homePagePrivateRef}
                    currentWallet={currentWallet}
                    setHomePagePrivate={changeHomePagePrivate}
                    homePagePrivate={homePagePrivate}
                    currentStatus={currentStatus} />
            </Restricted>
            {initAlphaInfo.allAlpha && (
                <label
                    className={style.container}
                    onClick={handleCheckBox}>
                    <div className={`${style.checkmark} ${checkAlpha ? style.checked : ""}`}></div>
                    <span>{t('RODIN_HEADER_ALPHA_CHAN')}</span>
                </label>)}
            <div className={`w-[257px] px-[20px] py-[12px] text-sm absolute top-0 left-1/2 -translate-x-1/2 translate-y-[calc(-100%-20px)] transition-300-ease bg-[rgba(255,255,255,0.1)] backdrop-blur-[60px] rounded-xl text-[rgba(255,255,255,0.6)] text-left ${multiImgTipBox ? "opacity-100 visible" : "opacity-0 invisible"}`}>
                {t('RODIN_HEADER_UNLOCK_MULTI_TIPS_1')} <span className='text-white'>{t('RODIN_HEADER_UNLOCK_MULTI_TIPS_2')}</span> {t('RODIN_HEADER_UNLOCK_MULTI_TIPS_3')}. <span onClick={handleOpenSub} className='relative text-[#28e4f0] after:absolute after:[content:""] after:left-0 after:bottom-[-2px] after:transition-300-ease cursor-pointer after:bg-[#28e4f0] after:w-0 after:h-[1px] hover:after:w-full'>{t('RODIN_HEADER_UNLOCK_MULTI_TIPS_4')}!</span>
            </div>

            <div className={`${style.boxShadow}  ${currentStatus ? style.gennerating : ""} ${generateDisabled ? style.generateDisabled : ""}`}></div>

            <div
                // onMouseEnter={handlerInitWeight}
                id='rodinGenerateBtn'
                className={`${style.generateBtn} ${currentStatus || generateDisabled ? style.gennerating : style.default} ${showMultibox && !currentStatus && !multiImgTipBox ? style.multi : ""}`}>
                <span className={`${style.generateText} ${currentStatus ? style.gennerating : ""} ${generateDisabled ? style.generateDisabled : ""}`}>
                    {currentStatus ? StateMap[currentStatus] : t('BUTTON_GENERATE')}
                </span>

                {
                    showMultibox && !currentStatus && (
                        <div className={`${style.multiBox} opacity-0 invisible absolute-center w-full h-full flex items-center [border-radius:inherit] overflow-hidden`}>
                            <div className='relative z-[1] peer/multi w-1/2 h-full flex-center transition-300-ease text-[rgba(255,255,255,0.6)] hover:text-white' onClick={handlerClickWeight.bind(null, 0)}>{t('BUTTON_MULTIVIEW')}</div>
                            <div className='relative z-[1] peer/fuse w-1/2 h-full flex-center transition-300-ease text-[rgba(255,255,255,0.6)] hover:text-white' onClick={handlerClickWeight.bind(null, 1)}>{t('BUTTON_FUSION')}</div>
                            <div className='absolute-y-center [will-change:left] [transform:translateZ(0)] z-0 left-[60%] peer-hover/multi:left-[10%] peer-hover/fuse:left-[60%] transition-300-ease [background:linear-gradient(180deg,#28E4F0_7.35%,#28B4F0_119.23%)] w-[56px] h-[12px] rounded-xl blur-[10px]'></div>
                        </div>
                    )
                }
            </div>
        </div>

    )
})

InputArea.displayName = 'InputArea'
GenrateArea.displayName = 'GenrateArea'
PageOne.displayName = 'PageOne'
PageTwo.displayName = 'PageTwo'
export default NewRodin